/**
 * A function to create a log object for the 'menusSaveItem' event (evid: 1)
 *
 * Event description: User clicked on save item, and got a response from the server if it was saved successfuly or not
 *
 * @param {menusSaveItemParams} params - The parameters for this event
 * @property {boolean} inStock - Is the item in stock
 * @property {string} name - name
 * @property {string} priceString - The price in string format. When the price is null it mean this item has Price Variations!
 * @property {number} numOfPriceVariations - The number of price variations
 * @property {string} maxPriceVariationString - The maximum price variation
 * @property {string} flowType - which flow type the modal/panel is at. New/Edit/Duplicate etc
 * @property {string} description - the description the user inputed
 * @property {string} imagesUrls - an array of image urls URLs . The first image url represents the main image URL
 * @property {boolean} isOrdersAvailable - Is orders attributes available for this site while the item is being saved
 * @property {string} taxGroupId - the tax group id of the item
 * @property {string} errorType - The type of the error - validtion/ server/ etc...
 * @property {string} minPriceVariationString - The minimum price variation
 * @property {string} origin - a button/area from where the action originated from. for example an origin of a modal load can be a specific button that triggered it's load
 * @property {string} errorDescription - text that describes the error reason
 *
 * @property {boolean} allowSpecialRequestes - Is the item allowing speciel requests
 * @property {GUID} itemId - Item ID. Unique id in a site level
 * @property {boolean} isVisible - True if the item is shown. False if the item is hidden
 * @property {string} currency - currency type
 * @property {string} customLabels - an array of label ids that are attached to this item
 * @property {string} pageName - page_name
 * @property {boolean} isSuccessful - states if the save was succesful. if not there sould be an error description column
 * @property {string} priceVariations - The json array containing all the modifiers ids + their price in this item. Notice that the order of variants matter
 * @property {string} modifierGroups - array of modifier group ids
 * @property {boolean} isFeatured - if the item is featured item (AKA starred item)
 * @property {string} itemAvailability - same as menu / limit to particular days and times / limit to specific dates
 * @property {number} numberOfImages - number of images on the item
 * @property {string} hosting - -
 * @return {LogObject<menusSaveItemParams>} LogObject<menusSaveItemParams>
 */
export function menusSaveItem(params) {
    return { evid: 1, src: 159, endpoint: 'restaurants', params: params };
}
/**
 * A function to create a log object for the 'restaurantsUouPageStartedLoading' event (evid: 10)
 *
 * Event description: Widget of a restaurants' app started loading (live site/ site builder)
 *
 * @param {restaurantsUouPageStartedLoadingParams} params - The parameters for this event
 * @property {string} widgetId - The ID of the widget
 * @property {string} pageId - The id of the site builder page the action occurred in
 * @property {string} widgetName - The name of the widget, for example menus
 * @property {string} pageName - name of the page
 * @property {string} widgetInstanceId - Id of the widget inside editor or live site. This id is supposed to be unique for a site and widget
 * @property {string} hosting - was the page loaded from editor window, inside the BM, Editor x etc...
 * @property {string} product - the specific product this event is related to: menus/table reservations/orders etc
 * @return {LogObject<restaurantsUouPageStartedLoadingParams>} LogObject<restaurantsUouPageStartedLoadingParams>
 */
export function restaurantsUouPageStartedLoading(params) {
    return { evid: 10, src: 159, endpoint: 'restaurants', params: params };
}
/**
 * A function to create a log object for the 'menusSaveSection' event (evid: 101)
 *
 * Event description: User clicked on save section, and got a response from the server if it was saved successfuly or not
 *
 * @param {menusSaveSectionParams} params - The parameters for this event
 * @property {string} name - name
 * @property {string} flowType - which flow type the modal/panel is at. New/Edit/Duplicate etc
 * @property {string} description - the description the user inputed
 * @property {string} errorType - The type of the error - validtion/ server/ etc...
 * @property {string} origin - a button/area from where the action originated from. for example an origin of a modal load can be a specific button that triggered it's load
 * @property {string} errorDescription - text that describes the error reason
 *
 * @property {GUID} sectionId - Section ID. Unique id in a site level
 * @property {string} pageName - name of the page
 * @property {boolean} isSuccessful - states if the save was succesful. if not there sould be an error description column
 * @property {string} imagesUrls - an array of image urls URLs . The first image url represents the main image URL
 *
 * @property {string} sectionAvailability - same as menu / limit to particular days and times / limit to specific dates
 * @property {boolean} isVisible - True if the item is shown. False if the item is hidden
 *
 * @return {LogObject<menusSaveSectionParams>} LogObject<menusSaveSectionParams>
 */
export function menusSaveSection(params) {
    return { evid: 101, src: 159, endpoint: 'restaurants', params: params };
}
/**
 * A function to create a log object for the 'menusSaveMenu' event (evid: 102)
 *
 * Event description: User clicked on save Menu, and got a response from the server if it was saved successfuly or not
 *
 * @param {menusSaveMenuParams} params - The parameters for this event
 * @property {string} name - name
 * @property {string} flowType - which flow type the modal/panel is at. New/Edit/Duplicate etc
 * @property {string} description - the description the user inputed
 * @property {boolean} isDraft - As default the checkbox is clicked (true), this field is similar to is_visible
 * @property {string} errorType - The type of the error - validtion/ server/ etc...
 * @property {string} origin - a button/area from where the action originated from. for example an origin of a modal load can be a specific button that triggered it's load
 * @property {string} errorDescription - text that describes the error reason
 *
 * @property {string} pageName - name of the page
 * @property {boolean} isSuccessful - states if the save was succesful. if not there sould be an error description column
 * @property {GUID} menuId - Menu ID. Unique id site in a site level
 * @property {GUID} locationId - -
 * @return {LogObject<menusSaveMenuParams>} LogObject<menusSaveMenuParams>
 */
export function menusSaveMenu(params) {
    return { evid: 102, src: 159, endpoint: 'restaurants', params: params };
}
/**
 * A function to create a log object for the 'menusOpenSidePanel' event (evid: 103)
 *
 * Event description: User opened a side panel inside one of menus app in the business manager. Notice that there is the isOrdersAvailable field, indicating if the user has the orders app features inside the side panel editing options. This event also happens in the parallel screens in the owners app
 *
 * @param {menusOpenSidePanelParams} params - The parameters for this event
 * @property {boolean} isOrdersAvailable - Are Online Ordering editing option available for the user?
 * @property {string} panelName - panel name
 * @property {string} origin - a button/area from where the action originated from. for example an origin of a modal load can be a specific button that triggered it's load
 * @property {string} pageName - name of the page
 * @return {LogObject<menusOpenSidePanelParams>} LogObject<menusOpenSidePanelParams>
 */
export function menusOpenSidePanel(params) {
    return { evid: 103, src: 159, endpoint: 'restaurants', params: params };
}
/**
 * A function to create a log object for the 'menusCloseSidePanel' event (evid: 104)
 *
 * Event description: User Closed a side panel inside one of menus app in the business manager.Notice that when a user tries to close the panel while in the middle of editing it opens a 'discard changes modal'. When this happens, this event should not fire! Only once the modal closes this event fires, and if it occures after the user clicked on discard changes, then the origin will be 'discard changes modal'. These can also happen in the owners app parallel screens
 *
 * @param {menusCloseSidePanelParams} params - The parameters for this event
 * @property {string} panelName - panel name
 * @property {string} origin - a button/area from where the action originated from. for example an origin of a modal load can be a specific button that triggered it's load
 * @property {string} pageName - name of the page
 * @return {LogObject<menusCloseSidePanelParams>} LogObject<menusCloseSidePanelParams>
 */
export function menusCloseSidePanel(params) {
    return { evid: 104, src: 159, endpoint: 'restaurants', params: params };
}
/**
 * A function to create a log object for the 'menusSidePanelClick' event (evid: 105)
 *
 * Event description: User made a made a change in a side panel inside one of menus app in the business manager. Before saving the changes. These can also happen in the owners app parallel screens
 *
 * @param {menusSidePanelClickParams} params - The parameters for this event
 * @property {string} field - represents the title of the field being edited. For example if a user writes a description for a menu it will return 'description'
 * @property {string} flowType - which flow type the modal/panel is at. New/Edit/Duplicate etc
 * @property {boolean} isOrdersAvailable - Is orders attributes available in the panel
 * @property {GUID} id - The id of the object being edited.
 * @property {string} panelName - panel name
 * @property {string} pageName - name of the page
 * @property {string} type - the type of object, for example: item,section,menu etc
 * @property {string} value - most commonly paired with a field column, and the value is the acutal value related to that field
 * @return {LogObject<menusSidePanelClickParams>} LogObject<menusSidePanelClickParams>
 */
export function menusSidePanelClick(params) {
    return { evid: 105, src: 159, endpoint: 'restaurants', params: params };
}
/**
 * A function to create a log object for the 'menusPageFinishedLoading' event (evid: 106)
 *
 * Event description: a menu inside the menus page finished loading. This event contains extra data regarding menus related information such as number of items loaded in a page (not including collapsed items), total items in a page (including collapsed items) etc
 *
 * @param {menusPageFinishedLoadingParams} params - The parameters for this event
 * @property {string} pageName - name of the page
 * @property {GUID} menuId - Menu ID. Unique id site in a site level
 * @property {number} loadedItems - number of items loaded. does not include collapsed items. pair with total Items to find the amount of collapsed items
 * @return {LogObject<menusPageFinishedLoadingParams>} LogObject<menusPageFinishedLoadingParams>
 */
export function menusPageFinishedLoading(params) {
    return { evid: 106, src: 159, endpoint: 'restaurants', params: params };
}
/**
 * A function to create a log object for the 'menusMoreButtonAction' event (evid: 107)
 *
 * Event description: User clicked on an option inside of the more button clickable list
 *
 * @param {menusMoreButtonActionParams} params - The parameters for this event
 * @property {string} origin - a button/area from where the action originated from. for example an origin of a modal load can be a specific button that triggered it's load
 * @property {string} pageName - name of the page
 * @property {string} action - The specific action
 * @return {LogObject<menusMoreButtonActionParams>} LogObject<menusMoreButtonActionParams>
 */
export function menusMoreButtonAction(params) {
    return { evid: 107, src: 159, endpoint: 'restaurants', params: params };
}
/**
 * A function to create a log object for the 'menusAddObjectClick' event (evid: 108)
 *
 * Event description: User clicked on an add object(menu,section,item,etc...) button
 *
 * @param {menusAddObjectClickParams} params - The parameters for this event
 * @property {GUID} id - id. if its modifiers so midifier_group_id
 * @property {string} origin - a button/area from where the action originated from. for example an origin of a modal load can be a specific button that triggered it's load
 * @property {string} pageName - name of the page
 * @property {string} type - the type of object, for example: item,section,menu etc
 * @property {GUID} locationId - -
 * @return {LogObject<menusAddObjectClickParams>} LogObject<menusAddObjectClickParams>
 */
export function menusAddObjectClick(params) {
    return { evid: 108, src: 159, endpoint: 'restaurants', params: params };
}
/**
 * A function to create a log object for the 'menusDeleteObject' event (evid: 109)
 *
 * Event description: User deleted an object (item/section/menu) from the menus app. Most commonly through one of the delete object modals. NOTICE this event fires only when the user pressed the delete button. If an entity was deleted as result of a deletion of a parent entity this event will not fire. For example, if a section was deleted, and all of it's items were deleted with it, it will not fire this event for each item
 *
 * @param {menusDeleteObjectParams} params - The parameters for this event
 * @property {boolean} itemsDeletes - rue if the user marked check to delete all items in section/ items in menu
 * @property {boolean} itemsDeleted - rue if the user marked check to delete all items in section/ items in menu
 * @property {GUID} id - an id of an object. Should be connected to a type field that states which object
 * @property {string} origin - a button/area from where the action originated from. for example an origin of a modal load can be a specific button that triggered it's load
 * @property {number} numberItems - if items in object were deleted, how many
 * @property {string} errorDescription - If the deletion was not succesful send the. error description
 * @property {string} pageName - name of the page
 * @property {string} type - the type of object, for example: item/section/menu/label etc
 * @property {boolean} isSuccessful - Did the deletion occurred successfully
 * @return {LogObject<menusDeleteObjectParams>} LogObject<menusDeleteObjectParams>
 */
export function menusDeleteObject(params) {
    return { evid: 109, src: 159, endpoint: 'restaurants', params: params };
}
/**
 * A function to create a log object for the 'restaurantsUouPageFinishedLoading' event (evid: 11)
 *
 * Event description: Widget of a restaurants' app finished loading (live site/ site builder)
 *
 * @param {restaurantsUouPageFinishedLoadingParams} params - The parameters for this event
 * @property {string} widgetId - An ID for the widget
 * @property {string} pageId - The id of the site builder page the action occurred in
 * @property {string} widgetName - The widget's name
 * @property {number} loadingTime - load time in miliseconds
 * @property {boolean} isMenusDefaultPage - Is this the default page menus widget is installed on?
 * @property {string} pageName - name of the page
 * @property {string} widgetInstanceId - Id of the widget inside editor or live site. This id is supposed to be unique for a site and widget
 * @property {string} hosting - editor/editor X/viewer(live site desktop)/ mobile(live site, mobile web). NOTICE you can use view_mode to aggregate live site(both mobile web and desktopn)
 * @property {string} product - the specific product this event is related to: menus/table reservations/orders etc
 * @property {GUID} locationId - -
 * @property {boolean} isOoi - indicates if the builder is OOI (or blocks)
 * @property {GUID} menuId - -
 * @return {LogObject<restaurantsUouPageFinishedLoadingParams>} LogObject<restaurantsUouPageFinishedLoadingParams>
 */
export function restaurantsUouPageFinishedLoading(params) {
    return { evid: 11, src: 159, endpoint: 'restaurants', params: params };
}
/**
 * A function to create a log object for the 'menusEditButtonClick' event (evid: 110)
 *
 * Event description: User clicked the edit button of an object inside the menus app to start editing it
 *
 * @param {menusEditButtonClickParams} params - The parameters for this event
 * @property {GUID} id - an id of an object. Should be connected to a type field that states which object
 * @property {string} origin - a button/area from where the action originated from. for example an origin of a modal load can be a specific button that triggered it's load
 * @property {string} pageName - name of the page
 * @property {string} type - the type of object, for example: item,section,menu etc
 * @return {LogObject<menusEditButtonClickParams>} LogObject<menusEditButtonClickParams>
 */
export function menusEditButtonClick(params) {
    return { evid: 110, src: 159, endpoint: 'restaurants', params: params };
}
/**
 * A function to create a log object for the 'menusCollapseAllSections' event (evid: 111)
 *
 * Event description: User clicked on collapse all sections. Events sent after they were collapsed.
 *
 * @param {menusCollapseAllSectionsParams} params - The parameters for this event
 * @property {number} numOfSections - number of section
 * @property {string} origin - a button/area from where the action originated from. for example an origin of a modal load can be a specific button that triggered it's load
 * @property {string} pageName - name of the page
 * @property {GUID} menuId - Menu ID. Unique id site in a site level
 * @return {LogObject<menusCollapseAllSectionsParams>} LogObject<menusCollapseAllSectionsParams>
 */
export function menusCollapseAllSections(params) {
    return { evid: 111, src: 159, endpoint: 'restaurants', params: params };
}
/**
 * A function to create a log object for the 'menusCollapseSectionClick' event (evid: 112)
 *
 * Event description: User clicked on collapse/un collapse button of a specific section. The status field states the status after the click
 *
 * @param {menusCollapseSectionClickParams} params - The parameters for this event
 * @property {string} state - the last state after the click
 * @property {number} numOfItems - number of items
 * @property {string} origin - a button/area from where the action originated from. for example an origin of a modal load can be a specific button that triggered it's load
 * @property {GUID} sectionId - Section ID. Unique id in a site level
 * @property {string} pageName - name of the page
 * @property {GUID} menuId - Menu ID. Unique id site in a site level
 * @return {LogObject<menusCollapseSectionClickParams>} LogObject<menusCollapseSectionClickParams>
 */
export function menusCollapseSectionClick(params) {
    return { evid: 112, src: 159, endpoint: 'restaurants', params: params };
}
/**
 * A function to create a log object for the 'menusDeleteButtonClick' event (evid: 113)
 *
 * Event description: User clicked the delete button of an object inside the menus app to start deleting it
 *
 * @param {menusDeleteButtonClickParams} params - The parameters for this event
 * @property {GUID} id - an id of an object. Should be connected to a type field that states which object
 * @property {string} origin - a button/area from where the action originated from. for example an origin of a modal load can be a specific button that triggered it's load
 * @property {string} pageName - name of the page
 * @property {string} type - the type of object, for example: item,section,menu etc
 * @return {LogObject<menusDeleteButtonClickParams>} LogObject<menusDeleteButtonClickParams>
 */
export function menusDeleteButtonClick(params) {
    return { evid: 113, src: 159, endpoint: 'restaurants', params: params };
}
/**
 * A function to create a log object for the 'menusBulkDelete' event (evid: 114)
 *
 * Event description: When a user uses the bulk delete in order to delete multiple objects (Of the same type)
 *
 * @param {menusBulkDeleteParams} params - The parameters for this event
 * @property {string} errorDescription - If the deletion was not succesful send the. error description
 * @property {string} idsArray - array of all the ids that were deleted with the section
 * @property {string} pageName - name of the page
 * @property {string} type - the type of objects deleted
 * @property {boolean} isSuccessful - Did the deletion occurred successfully
 * @return {LogObject<menusBulkDeleteParams>} LogObject<menusBulkDeleteParams>
 */
export function menusBulkDelete(params) {
    return { evid: 114, src: 159, endpoint: 'restaurants', params: params };
}
/**
 * A function to create a log object for the 'menusEditorElementsPanelCheckboxAction' event (evid: 115)
 *
 * Event description: User clicked on a button inside the elements panel that made a difference in the design. for example clicked a checkbox of section title. NOTICE there is more than one elements panel. for example you can arrive at the "menu section elements" panel when clicking inside at the section are of the menus widget
 *
 * @param {menusEditorElementsPanelCheckboxActionParams} params - The parameters for this event
 * @property {string} widgetId - an id for the specific widget
 * @property {string} pageId - The id of the site builder page the action occurred in
 * @property {string} widgetName - Menus
 * @property {string} panelName - The panel name: menu elements/menu section elements/etc...
 * @property {string} sitePageName - Name of the page inside the live site/editor. This is something the user can edit
 * @property {string} widgetInstanceId - Id of the widget inside editor or live site. This id is supposed to be unique for a site and widget
 * @property {string} visibleElementsArray - an array of all the elements that are visible (aka those that are checked) after the click
 * @property {GUID} msid - msid
 * @property {string} elementName - the name of the element that was checked/unchecked
 * @property {string} action - check / uncheck
 * @return {LogObject<menusEditorElementsPanelCheckboxActionParams>} LogObject<menusEditorElementsPanelCheckboxActionParams>
 */
export function menusEditorElementsPanelCheckboxAction(params) {
    return { evid: 115, src: 159, endpoint: 'restaurants', params: params };
}
/**
 * A function to create a log object for the 'menusEditorMenuSettingsPanelAction' event (evid: 116)
 *
 * Event description: User clicked on a button inside the menu settings button that made a difference in the design.
 * For example clicked on a menu checkbox
 *
 * @param {menusEditorMenuSettingsPanelActionParams} params - The parameters for this event
 * @property {string} visibleMenusArray - an array of all the menus that are visible (aka those that are checked) after the click
 * @property {string} widgetId - an id for the specific widget
 * @property {string} field - menu picking/ create new menu page
 * @property {string} pageId - The id of the site builder page the action occurred in
 * @property {string} widgetName - Menus
 * @property {string} sitePageName - Name of the page inside the live site/editor. This is something the user can edit
 * @property {boolean} isMenusDefaultPage - Is this the default page menus widget is installed on?
 * @property {string} widgetInstanceId - Id of the widget inside editor or live site. This id is supposed to be unique for a site and widget
 * @property {GUID} msid - msid
 * @property {string} value - visible/hidden/show all/reorder
 * @return {LogObject<menusEditorMenuSettingsPanelActionParams>} LogObject<menusEditorMenuSettingsPanelActionParams>
 */
export function menusEditorMenuSettingsPanelAction(params) {
    return { evid: 116, src: 159, endpoint: 'restaurants', params: params };
}
/**
 * A function to create a log object for the 'menusSaveMenuItemLabel' event (evid: 117)
 *
 * Event description: User clicked on save Label, and got a response from the server if it was saved successfully or not. Including add/edit Item Label
 *
 * @param {menusSaveMenuItemLabelParams} params - The parameters for this event
 * @property {string} name - name
 * @property {string} flowType - which flow type the modal/panel is at. New/Edit/Duplicate etc
 * @property {string} errorType - The type of the error - validtion/ server/ etc...
 * @property {string} origin - a button/area from where the action originated from. for example an origin, can be: save button-edit label modal
 * @property {GUID} labelId - Label ID. Unique id site in a site level
 * @property {string} errorDescription - text that describes the error reason
 *
 * @property {string} pageName - name of the page
 * @property {boolean} isSuccessful - states if the save was succesful. if not there sould be an error description column
 * @property {string} imageUrl - the url of the icon
 * @return {LogObject<menusSaveMenuItemLabelParams>} LogObject<menusSaveMenuItemLabelParams>
 */
export function menusSaveMenuItemLabel(params) {
    return { evid: 117, src: 159, endpoint: 'restaurants', params: params };
}
/**
 * A function to create a log object for the 'menusDeleteMenuWithAllSections' event (evid: 118)
 *
 * Event description: User deleted a menu and chose to delete all the sections inside of it. (deleting the items inside those sections as well) Might only be relevant for menu showcase V1
 *
 * @param {menusDeleteMenuWithAllSectionsParams} params - The parameters for this event
 * @property {string} errorDescription - If the deletion was not succesful send the. error description
 * @property {string} pageName - name of the page
 * @property {boolean} isSuccessful - Did the deletion occurred successfully
 * @property {string} sectionsArray - array of all the sections that were deleted with the section
 * @property {GUID} menuId - menu Id
 * @return {LogObject<menusDeleteMenuWithAllSectionsParams>} LogObject<menusDeleteMenuWithAllSectionsParams>
 */
export function menusDeleteMenuWithAllSections(params) {
    return { evid: 118, src: 159, endpoint: 'restaurants', params: params };
}
/**
 * A function to create a log object for the 'menusManageLabelsButtonClick' event (evid: 119)
 *
 * Event description: User clicked a Manage Labels button - opening the manage labels modal
 *
 * @param {menusManageLabelsButtonClickParams} params - The parameters for this event
 * @property {string} origin - a button/area from where the action originated from. for example an origin of a modal load can be a specific button that triggered it's load
 * @property {string} pageName - name of the page the action occurred in
 * @return {LogObject<menusManageLabelsButtonClickParams>} LogObject<menusManageLabelsButtonClickParams>
 */
export function menusManageLabelsButtonClick(params) {
    return { evid: 119, src: 159, endpoint: 'restaurants', params: params };
}
/**
 * A function to create a log object for the 'restaurantsEditorPanelLoad' event (evid: 12)
 *
 * Event description: User loads a widget editing panel inside the editor of a restaurants app
 *
 * @param {restaurantsEditorPanelLoadParams} params - The parameters for this event
 * @property {string} widgetId - an id for the specific widget
 * @property {string} pageId - The id of the site builder page the action occurred in
 * @property {string} widgetName - Name of the widget, for example menus
 * @property {string} panelName - panel name
 * @property {string} origin - a button/area from where the action originated from. for example an origin of a modal load can be a specific button that triggered it's load
 * @property {string} sitePageName - Name of the page inside the live site/editor. This is something the user can edit
 * @property {string} widgetInstanceId - Id of the widget inside editor or live site. This id is supposed to be unique for a site and widget
 * @property {GUID} msid - msid
 * @property {string} product - the specific product this event is related to: menus/table reservations/orders etc
 * @property {boolean} isOoi - indicates if the builder is OOI (or blocks)
 *
 * @return {LogObject<restaurantsEditorPanelLoadParams>} LogObject<restaurantsEditorPanelLoadParams>
 */
export function restaurantsEditorPanelLoad(params) {
    return { evid: 12, src: 159, endpoint: 'restaurants', params: params };
}
/**
 * A function to create a log object for the 'menusModalAction' event (evid: 120)
 *
 * Event description: User made a made a change in a modal inside one of menus app in the business manager. Before saving the changes
 *
 * @param {menusModalActionParams} params - The parameters for this event
 * @property {string} field - represents the title of the field being edited. For example if a user writes a description for a menu it will return 'description'
 * @property {string} flowType - which flow type the modal/panel is at. New/Edit/Duplicate etc
 * @property {GUID} id - an id of an object. Should be connected to a type field that states which object
 * @property {string} pageName - name of the page
 * @property {string} type - the type of object, for example: item,section,menu etc
 * @property {string} modalName - modal name
 * @property {string} value - most commonly paired with a field column, and the value is the acutal value related to that field
 * @return {LogObject<menusModalActionParams>} LogObject<menusModalActionParams>
 */
export function menusModalAction(params) {
    return { evid: 120, src: 159, endpoint: 'restaurants', params: params };
}
/**
 * A function to create a log object for the 'menusReOrderObject' event (evid: 121)
 *
 * Event description: User reordered an object, for example, if a user reorders items inside of a section, the type will be item. IF YOU WANT THE LAST ORDER, USE SERVER EVENTS WHEN POSSIBLE
 *
 * @param {menusReOrderObjectParams} params - The parameters for this event
 * @property {GUID} id - an id of an object. Should be connected to a type field that states which object
 * @property {string} origin - a button/area from where the action originated from. for example an origin of a modal load can be a specific button that triggered it's load
 * @property {string} errorDescription - If the deletion was not succesful send the. error description
 * @property {string} pageName - name of the page
 * @property {string} type - the type of object, for example: item/section/menu/label etc
 * @property {string} orderArray - An array of the objects, with the new order
 * @property {boolean} isSuccessful - Did the deletion occurred successfully
 * @return {LogObject<menusReOrderObjectParams>} LogObject<menusReOrderObjectParams>
 */
export function menusReOrderObject(params) {
    return { evid: 121, src: 159, endpoint: 'restaurants', params: params };
}
/**
 * A function to create a log object for the 'menusOwnersAppEntryPointClick' event (evid: 122)
 *
 * Event description: User clicked on one of menus app entry points
 *
 * @param {menusOwnersAppEntryPointClickParams} params - The parameters for this event
 * @property {string} destinationPageName - The page that the user is about to land in, for example menus/items etc...
 * @property {string} origin - a button/area from where the action originated from. for example an origin of a modal load can be a specific button that triggered it's load
 * @property {string} pageName - name of the page
 * @return {LogObject<menusOwnersAppEntryPointClickParams>} LogObject<menusOwnersAppEntryPointClickParams>
 */
export function menusOwnersAppEntryPointClick(params) {
    return { evid: 122, src: 159, endpoint: 'restaurants', params: params };
}
/**
 * A function to create a log object for the 'menusRemoveItemFromSection' event (evid: 123)
 *
 * Event description: User removed an item from a section. This event also checks with the server that the change was made
 *
 * @param {menusRemoveItemFromSectionParams} params - The parameters for this event
 * @property {string} origin - a button/area from where the action originated from. for example an origin of a modal load can be a specific button that triggered it's load
 * @property {string} errorDescription - If the removal was not successful send the. error description
 * @property {string} sectionId - sectionId
 * @property {string} itemId - itemId
 * @property {string} pageName - name of the page
 * @property {boolean} isSuccessful - Did the removal occurred successfully
 * @return {LogObject<menusRemoveItemFromSectionParams>} LogObject<menusRemoveItemFromSectionParams>
 */
export function menusRemoveItemFromSection(params) {
    return { evid: 123, src: 159, endpoint: 'restaurants', params: params };
}
/**
 * A function to create a log object for the 'menusNavigationClick' event (evid: 124)
 *
 * Event description: User clicked on a navigation button (any button in the menus app that links to a different page)
 *
 * @param {menusNavigationClickParams} params - The parameters for this event
 * @property {string} destinationPageName - The page that the user is about to land in, for example menus/items etc...
 * @property {string} origin - a button/area from where the action originated from. for example an origin of a modal load can be a specific button that triggered it's load
 * @property {string} pageName - name of the page
 * @property {GUID} locationId - -
 * @return {LogObject<menusNavigationClickParams>} LogObject<menusNavigationClickParams>
 */
export function menusNavigationClick(params) {
    return { evid: 124, src: 159, endpoint: 'restaurants', params: params };
}
/**
 * A function to create a log object for the 'menusDuplicateObjectClick' event (evid: 125)
 *
 * Event description: User clicked on a duplicate object(menu,section,item,etc...) button. This does not include server save, only the start of the duplication flow.
 *
 * @param {menusDuplicateObjectClickParams} params - The parameters for this event
 * @property {string} origin - a button/area from where the action originated from. for example an origin of a modal load can be a specific button that triggered it's load
 * @property {string} pageName - name of the page
 * @property {string} type - the type of object, for example: item,section,menu etc
 * @property {string} originId - the id of the object that is the origin of the duplication
 * @return {LogObject<menusDuplicateObjectClickParams>} LogObject<menusDuplicateObjectClickParams>
 */
export function menusDuplicateObjectClick(params) {
    return { evid: 125, src: 159, endpoint: 'restaurants', params: params };
}
/**
 * A function to create a log object for the 'menusSaveModifierOrPriceVariant' event (evid: 126)
 *
 * Event description: User clicked on save item, and in that save there were modifiers/price variants that were saved. The user got a response from the server if it was saved successfully or not
 *
 * @param {menusSaveModifierOrPriceVariantParams} params - The parameters for this event
 * @property {boolean} isPreselected - true/false
 * @property {string} flowType - which flow type the modal/panel is at. New/Edit/Duplicate etc
 * @property {string} errorType - The type of the error - validtion/ server/ etc...
 * @property {GUID} id - Modifier id
 * @property {string} origin - a button/area from where the action originated from. for example an origin of a modal load can be a specific button that triggered it's load
 * @property {string} errorDescription - text that describes the error reason
 *
 * @property {GUID} itemId - Item ID of the item the modifier were saved in
 * @property {string} pageName - name of the page
 * @property {string} type - variation/individual_modifier/etc...
 * @property {boolean} isSuccessful - states if the save was succesful. if not there sould be an error description column
 * @return {LogObject<menusSaveModifierOrPriceVariantParams>} LogObject<menusSaveModifierOrPriceVariantParams>
 */
export function menusSaveModifierOrPriceVariant(params) {
    return { evid: 126, src: 159, endpoint: 'restaurants', params: params };
}
/**
 * A function to create a log object for the 'menusSaveModifierGroup' event (evid: 127)
 *
 * Event description: User clicked on save item, and in that save there were modifier groups that were saved.The user got a response from the server if it was saved successfully or not
 *
 * @param {menusSaveModifierGroupParams} params - The parameters for this event
 * @property {string} name - name of the price variant
 * @property {boolean} isMandatory - true/false
 * @property {string} flowType - which flow type the modal/panel is at. New/Edit/Duplicate / Reusable etc
 * @property {number} maxSelections - max_selections
 * @property {string} errorType - The type of the error - validtion/ server/ etc...
 * @property {GUID} id - Modifier group id
 * @property {string} modifierGroupId - only if it’s not null (in the updates)
 * @property {string} origin - a button/area from where the action originated from. for example an origin of a modal load can be a specific button that triggered it's load
 * @property {string} modifiers - json array of modifiers
 * @property {number} minSelections - min_selections
 * @property {string} errorDescription - text that describes the error reason
 *
 * @property {GUID} itemId - Item ID of the item the modifier were saved in
 * @property {string} pageName - name of the page
 * @property {number} numPreselectedModifiers - num preselected modifiers
 * @property {string} type - optional/mandatory sinces Nov23. before - SINGLE_SELECT/ MULTI_SELECT/UNSPECIFIED_RULE_TYPE
 * @property {boolean} isSuccessful - states if the save was succesful. if not there sould be an error description column
 * @property {boolean} isNoLimit - true/false
 * @property {number} maxChoices - maximum number of extras the customer can choose. Relevant to mulitSelection only
 * @property {string} itemmIds -  list of al item ids that use this modifier group
 *
 * @property {number} numOfItemsInUse - the number of all the items that use this modifier group
 * @property {string} changedFields - what fields were changed in this “update” event?
 * @return {LogObject<menusSaveModifierGroupParams>} LogObject<menusSaveModifierGroupParams>
 */
export function menusSaveModifierGroup(params) {
    return { evid: 127, src: 159, endpoint: 'restaurants', params: params };
}
/**
 * A function to create a log object for the 'menusRemoveModifierFromModifierGroup' event (evid: 128)
 *
 * Event description: User removed a modifier from a modifier group. This event also checks with the server that the change was made
 *
 * @param {menusRemoveModifierFromModifierGroupParams} params - The parameters for this event
 * @property {string} modifierId - modifierId
 * @property {boolean} isPreselected - Ture/False
 * @property {string} modifierGroupId - modifierGroupId
 * @property {string} origin - a button/area from where the action originated from. for example an origin of a modal load can be a specific button that triggered it's load
 * @property {string} errorDescription - If the removal was not successful send the. error description
 * @property {string} pageName - name of the page
 * @property {boolean} isSuccessful - Did the removal occurred successfully
 * @return {LogObject<menusRemoveModifierFromModifierGroupParams>} LogObject<menusRemoveModifierFromModifierGroupParams>
 */
export function menusRemoveModifierFromModifierGroup(params) {
    return { evid: 128, src: 159, endpoint: 'restaurants', params: params };
}
/**
 * A function to create a log object for the 'menusRemoveModifierGroupFromItem' event (evid: 129)
 *
 * Event description: User removed a modifier group from an item . This event also checks with the server that the change was made
 *
 * @param {menusRemoveModifierGroupFromItemParams} params - The parameters for this event
 * @property {boolean} isMandatory - true/false
 * @property {string} flowType - new/edit
 * @property {number} maxSelections - max_selection number
 * @property {number} minChoices - min_selection number
 * @property {string} modifierGroupId - modifierGroupId
 * @property {string} origin - a button/area from where the action originated from. for example an origin of a modal load can be a specific button that triggered it's load
 * @property {number} minSelections - min_selection number
 * @property {string} errorDescription - If the removal was not successful send the. error description
 * @property {string} itemId - itemId
 * @property {string} pageName - name of the page
 * @property {number} numPreselectedModifiers - # of preselected modifiers
 * @property {boolean} isSuccessful - Did the removal occurred successfully
 * @property {boolean} isNoLimit - true/false
 * @return {LogObject<menusRemoveModifierGroupFromItemParams>} LogObject<menusRemoveModifierGroupFromItemParams>
 */
export function menusRemoveModifierGroupFromItem(params) {
    return { evid: 129, src: 159, endpoint: 'restaurants', params: params };
}
/**
 * A function to create a log object for the 'restaurantsEditorPanelClose' event (evid: 13)
 *
 * Event description: User closes a widget editing panel inside the editor of a restaurants app
 *
 * @param {restaurantsEditorPanelCloseParams} params - The parameters for this event
 * @property {string} widgetId - an id for the specific widget
 * @property {string} buttonType - The specific button clicked
 * @property {string} pageId - The id of the site builder page the action occurred in
 * @property {string} widgetName - Name of the widget, for example menus
 * @property {string} panelName - panel name
 * @property {string} sitePageName - Name of the page inside the live site/editor. This is something the user can edit
 * @property {string} widgetInstanceId - Id of the widget inside editor or live site. This id is supposed to be unique for a site and widget
 * @property {string} product - the specific product this event is related to: menus/table reservations/orders etc
 * @return {LogObject<restaurantsEditorPanelCloseParams>} LogObject<restaurantsEditorPanelCloseParams>
 */
export function restaurantsEditorPanelClose(params) {
    return { evid: 13, src: 159, endpoint: 'restaurants', params: params };
}
/**
 * A function to create a log object for the 'menusOrdersAttributesChange' event (evid: 130)
 *
 * Event description: User clicked on one of the buttons that trigger the hide/show orders attribute for menus app.
 *
 * @param {menusOrdersAttributesChangeParams} params - The parameters for this event
 * @property {string} lastState - hide/show
 * @property {string} origin - a button/area from where the action originated from. for example an origin of a modal load can be a specific button that triggered it's load
 * @property {string} errorDescription - If the deletion was not succesful send the. error description
 * @property {string} pageName - name of the page
 * @property {boolean} isSuccessful - Did the deletion occurred successfully
 * @return {LogObject<menusOrdersAttributesChangeParams>} LogObject<menusOrdersAttributesChangeParams>
 */
export function menusOrdersAttributesChange(params) {
    return { evid: 130, src: 159, endpoint: 'restaurants', params: params };
}
/**
 * A function to create a log object for the 'menusLiveSiteEditorPreviewNavigationClick' event (evid: 131)
 *
 * Event description: User clicked on a navigation button in the live site/preview mode of the menus app widget. This navigation switches between different menus in the in the widget.
 * The event use also to switch between menus sections.
 *
 * @param {menusLiveSiteEditorPreviewNavigationClickParams} params - The parameters for this event
 * @property {string} widgetId - An ID for the widget
 * @property {number} navigationType - Tabs / Dropdown
 * @property {number} numMenus - The number of menus presented in the horizontal menu
 * @property {string} widgetName - The widget's name
 * @property {string} menuNavigation - Tabs / Dropdown
 * @property {string} pageName - name of the page in live site/editor
 * @property {string} widgetInstanceId - Id of the widget inside editor or live site. This id is supposed to be unique for a site and widget
 * @property {string} object - menu/section
 * @property {number} numOfSections - The number of sections presented
 * @property {boolean} isOoi - -
 * @return {LogObject<menusLiveSiteEditorPreviewNavigationClickParams>} LogObject<menusLiveSiteEditorPreviewNavigationClickParams>
 */
export function menusLiveSiteEditorPreviewNavigationClick(params) {
    return { evid: 131, src: 159, endpoint: 'restaurants', params: params };
}
/**
 * A function to create a log object for the 'menusMoveItem' event (evid: 132)
 *
 * Event description: User moves / assigned an item / many items from one section to another section / many sections. Can happen between menus as well.
 *
 * @param {menusMoveItemParams} params - The parameters for this event
 * @property {string} error_type - validation/server/etc...
 * @property {string} originSectionId - origin sectionId, where the item was moved from
 * @property {string} origin - a button/area from where the action originated from. for example an origin of a modal load can be a specific button that triggered it's load
 * @property {string} errorDescription - If the move was not successful send the. error description
 * @property {string} itemId - itemId
 * @property {string} originMenuId - origin menuId, where the item was moved from
 * @property {string} targetMenuId - target menuId, where the item is moved to
 * @property {string} targetSectionId - target sectionId, where the item is moved to
 * @property {string} pageName - name of the page
 * @property {boolean} isSuccessful - Did the move occurred successfully
 * @property {string} targetMenuIds - -
 * @property {number} numberOfMenus - -
 * @property {string} targetSectionIds - if there is more than one target section
 * @property {number} numberOfItems - -
 * @return {LogObject<menusMoveItemParams>} LogObject<menusMoveItemParams>
 */
export function menusMoveItem(params) {
    return { evid: 132, src: 159, endpoint: 'restaurants', params: params };
}
/**
 * A function to create a log object for the 'menusMoveSection' event (evid: 133)
 *
 * Event description: User moves a section from one menu to another. This moves the entire section and all of the items inside of it to the new menu
 *
 * @param {menusMoveSectionParams} params - The parameters for this event
 * @property {string} error_type - validation/server/etc...
 * @property {string} origin - a button/area from where the action originated from. for example an origin of a modal load can be a specific button that triggered it's load
 * @property {string} errorDescription - If the move was not successful send the. error description
 * @property {string} sectionId - sectionId
 * @property {string} originMenuId - origin menuId, where the section was moved from
 * @property {string} targetMenuId - target menuId, where the section is moved to
 * @property {string} pageName - name of the page
 * @property {boolean} isSuccessful - Did the move occurred successfully
 * @return {LogObject<menusMoveSectionParams>} LogObject<menusMoveSectionParams>
 */
export function menusMoveSection(params) {
    return { evid: 133, src: 159, endpoint: 'restaurants', params: params };
}
/**
 * A function to create a log object for the 'menusMoveItemModalMenuDrilldownClick' event (evid: 134)
 *
 * Event description: The user clicked on one of the menus inside the move item modal, this click is a drilldown
 *
 * @param {menusMoveItemModalMenuDrilldownClickParams} params - The parameters for this event
 * @property {string} chosenMenuId - menuId of the menu chosen
 * @property {number} numberOfSections - Number of section in the chosen menu (should be 0 if empty)
 * @property {boolean} isCurrentMenu - Is the menu clicked, the current menu of the item
 * @property {string} itemId - itemId that is being moved
 * @property {string} pageName - name of the page
 * @return {LogObject<menusMoveItemModalMenuDrilldownClickParams>} LogObject<menusMoveItemModalMenuDrilldownClickParams>
 */
export function menusMoveItemModalMenuDrilldownClick(params) {
    return { evid: 134, src: 159, endpoint: 'restaurants', params: params };
}
/**
 * A function to create a log object for the 'menusEditorMenuLayoutPick' event (evid: 135)
 *
 * Event description: User clicked on a menu layout option. In the fields below there is a field stating if the layout allows images allow_images
 *
 * @param {menusEditorMenuLayoutPickParams} params - The parameters for this event
 * @property {string} widgetId - an id for the specific widget
 * @property {string} pageId - The id of the site builder page the action occurred in
 * @property {boolean} allowImages - If the layout allows images, as only some of the layouts have the option to display images
 * @property {string} widgetName - Menus
 * @property {string} sitePageName - Name of the page inside the live site/editor. This is something the user can edit
 * @property {string} layout - layout id/ layout name
 * @property {string} widgetInstanceId - Id of the widget inside editor or live site. This id is supposed to be unique for a site and widget
 * @property {GUID} msid - msid
 * @return {LogObject<menusEditorMenuLayoutPickParams>} LogObject<menusEditorMenuLayoutPickParams>
 */
export function menusEditorMenuLayoutPick(params) {
    return { evid: 135, src: 159, endpoint: 'restaurants', params: params };
}
/**
 * A function to create a log object for the 'menusTabSwitch' event (evid: 136)
 *
 * Event description: User clicked on a different tab inside one of menus page.
 * For example: user clicked on the variants tab inside the items page
 *
 * @param {menusTabSwitchParams} params - The parameters for this event
 * @property {string} destinationTab - The tab that the user is about to land in, for example items/variants/modifiers etc...
 * @property {string} currentTab - The tab that the user was in before the click, for example items/variants/modifiers etc...
 * @property {string} pageName - name of the page
 * @return {LogObject<menusTabSwitchParams>} LogObject<menusTabSwitchParams>
 */
export function menusTabSwitch(params) {
    return { evid: 136, src: 159, endpoint: 'restaurants', params: params };
}
/**
 * A function to create a log object for the 'menusItemsPageHover' event (evid: 137)
 *
 * Event description: User hovered on an item/modifier/variant inside the items page
 *
 * @param {menusItemsPageHoverParams} params - The parameters for this event
 * @property {number} numberOfEntities - The number of different entities inside the hover. For example, if the hover is on the "included in" column, then it wil be the number of items the modifier/variant is included in
 * @property {string} hoverContent - The hover content
 * @property {string} id - the id of the item/variant/modifier (should use with the type field)
 * @property {string} column_title - The column the user is hovering on : menus/included in/etc...
 * @property {string} type - item/variant/modifier
 * @return {LogObject<menusItemsPageHoverParams>} LogObject<menusItemsPageHoverParams>
 */
export function menusItemsPageHover(params) {
    return { evid: 137, src: 159, endpoint: 'restaurants', params: params };
}
/**
 * A function to create a log object for the 'menusDuplicateMenu' event (evid: 138)
 *
 * Event description: User duplicates menu.
 * This event includes data on the sections and items that are duplicated as result as well
 *
 * @param {menusDuplicateMenuParams} params - The parameters for this event
 * @property {string} errorDescription - If the deletion was not succesful send the. error description
 * @property {string} pageName - name of the page
 * @property {boolean} isSuccessful - Did the deletion occurred successfully
 * @property {string} sectionsArray - array of all the section ids that were duplicated with the menu
 * @property {GUID} menuId - menu Id after the duplication
 * @property {string} itemsArray - array of all the Item ids that were duplicated with the menu
 * @property {string} menuItems - copy / shared
 * @property {string} menuIds - for example in duplicate menu to more than one location flow
 * @return {LogObject<menusDuplicateMenuParams>} LogObject<menusDuplicateMenuParams>
 */
export function menusDuplicateMenu(params) {
    return { evid: 138, src: 159, endpoint: 'restaurants', params: params };
}
/**
 * A function to create a log object for the 'menusEditorShowHidePlaceholderImage' event (evid: 139)
 *
 * Event description: User clicked on a button regarding showing or hiding placeholder images
 *
 * @param {menusEditorShowHidePlaceholderImageParams} params - The parameters for this event
 * @property {string} widgetId - an id for the specific widget
 * @property {string} menusShowImage - array of menu ids of menus that show the placeholder image
 * @property {string} sectionsShowImage - array of section ids of sections that show the placeholder image
 * @property {string} pageId - The id of the site builder page the action occurred in
 * @property {string} widgetName - Menus
 * @property {string} sitePageName - Name of the page inside the live site/editor. This is something the user can edit
 * @property {string} widgetInstanceId - Id of the widget inside editor or live site. This id is supposed to be unique for a site and widget
 * @property {GUID} msid - msid
 * @property {string} action - The type of action occurring related to placeholder image such as : "disable on all menus", "enable on all menus"etc...""
 * @return {LogObject<menusEditorShowHidePlaceholderImageParams>} LogObject<menusEditorShowHidePlaceholderImageParams>
 */
export function menusEditorShowHidePlaceholderImage(params) {
    return { evid: 139, src: 159, endpoint: 'restaurants', params: params };
}
/**
 * A function to create a log object for the 'restaurantsEditorPanelNavigationClick' event (evid: 14)
 *
 * Event description: Restaurants -> Editor -> Panel Navigation Click.
 *
 * @param {restaurantsEditorPanelNavigationClickParams} params - The parameters for this event
 * @property {string} widgetId - an id for the specific widget
 * @property {string} lastLevel - The last and most detailed level , i.e : color picker/ fonts/themes/etc…
 * If there is only a first level then the last and first level will send the same value.
 * @property {string} pageId - The id of the site builder page the action occurred in
 * @property {string} widgetName - Name of the widget, for example menus
 * @property {string} panelName - panel name
 * @property {string} sitePageName - Name of the page inside the live site/editor. This is something the user can edit
 * @property {string} firstLevel - The first navigation level, i.e : menu title/ section title/ labels/ etc…
 * @property {string} widgetInstanceId - Id of the widget inside editor or live site. This id is supposed to be unique for a site and widget
 * @property {string} fullPath - The complete level path for example : fill color & opacity, background, color picker
 * @property {string} product - the specific product this event is related to: menus/table reservations/orders etc
 * @return {LogObject<restaurantsEditorPanelNavigationClickParams>} LogObject<restaurantsEditorPanelNavigationClickParams>
 */
export function restaurantsEditorPanelNavigationClick(params) {
    return { evid: 14, src: 159, endpoint: 'restaurants', params: params };
}
/**
 * A function to create a log object for the 'menusEditorPlaceholderImageDesignAction' event (evid: 140)
 *
 * Event description: User clicked on a button regarding the design of placeholder images, for example, changing the image
 *
 * @param {menusEditorPlaceholderImageDesignActionParams} params - The parameters for this event
 * @property {string} widgetId - an id for the specific widget
 * @property {string} pageId - The id of the site builder page the action occurred in
 * @property {string} widgetName - Menus
 * @property {string} sitePageName - Name of the page inside the live site/editor. This is something the user can edit
 * @property {string} widgetInstanceId - Id of the widget inside editor or live site. This id is supposed to be unique for a site and widget
 * @property {string} imageUrl - The placeholder image url
 * @property {GUID} msid - msid
 * @property {string} action - The type of action occurring related to placeholder image such as : change image, reset image, adjust image, etc
 * @return {LogObject<menusEditorPlaceholderImageDesignActionParams>} LogObject<menusEditorPlaceholderImageDesignActionParams>
 */
export function menusEditorPlaceholderImageDesignAction(params) {
    return { evid: 140, src: 159, endpoint: 'restaurants', params: params };
}
/**
 * A function to create a log object for the 'tableReservationsReservationsPageTabSelected' event (evid: 1406)
 *
 * Event description: when users click on the reservations / requests tab
 *
 * @param {tableReservationsReservationsPageTabSelectedParams} params - The parameters for this event
 * @property {number} rowsNumberSource - number of reservations / requests in the source tab
 * @property {string} tabName - reservations / requests
 * @property {GUID} reservationLocationId - -
 * @property {string} viewType - floor_plan_view / reservations_list_view
 * @property {string} rest_id - -
 * @property {number} rowsNumberTarget - number of reservations / requests in the target tab
 * @return {LogObject<tableReservationsReservationsPageTabSelectedParams>} LogObject<tableReservationsReservationsPageTabSelectedParams>
 */
export function tableReservationsReservationsPageTabSelected(params) {
    return { evid: 1406, src: 159, endpoint: 'restaurants', params: params };
}
/**
 * A function to create a log object for the 'tableReservationsBoClickAddNewReservation' event (evid: 1407)
 *
 * Event description: in the table reservations bo page, when a user clicks on create reservation and then on reservation/ walk in
 *
 * @param {tableReservationsBoClickAddNewReservationParams} params - The parameters for this event
 * @property {GUID} reservationLocationId - -
 * @property {string} viewType - floor_plan_view / reservations_list_view / mobile_dashboard_view
 * @property {string} origin - reservations_list / floor_plan_popover / header / footer / widget
 * @property {GUID} locationId - -
 * @property {string} reservationType - reservation / walk_in
 * @return {LogObject<tableReservationsBoClickAddNewReservationParams>} LogObject<tableReservationsBoClickAddNewReservationParams>
 */
export function tableReservationsBoClickAddNewReservation(params) {
    return { evid: 1407, src: 159, endpoint: 'restaurants', params: params };
}
/**
 * A function to create a log object for the 'tableReservationsBoReservationRequestAction' event (evid: 1408)
 *
 * Event description: After the user open the reservation request modal, this event will send if he clicked accept / declined.
 *
 * @param {tableReservationsBoReservationRequestActionParams} params - The parameters for this event
 * @property {GUID} reservationId - -
 * @property {GUID} reservationLocationId - -
 * @property {string} viewType - floor_plan_view / reservations_list_view
 * @property {GUID} locationId - -
 * @property {string} action - accept / decline
 * @property {string} placement - placement
 * @property {string} experienceId - experience id
 * @return {LogObject<tableReservationsBoReservationRequestActionParams>} LogObject<tableReservationsBoReservationRequestActionParams>
 */
export function tableReservationsBoReservationRequestAction(params) {
    return { evid: 1408, src: 159, endpoint: 'restaurants', params: params };
}
/**
 * A function to create a log object for the 'menusEditorSeoAction' event (evid: 141)
 *
 * Event description: User clicked/typed something inside the SEO tab in the editor
 *
 * @param {menusEditorSeoActionParams} params - The parameters for this event
 * @property {string} tabName - for example seo basics
 * @property {string} pageId - The id of the site builder page the action occurred in
 * @property {string} errorType - server/validation/etc...
 * @property {string} sitePageName - Name of the page inside the live site/editor. This is something the user can edit
 * @property {string} errorDescription - detailed description of error
 * @property {boolean} isSuccessful - was the action completed successfully
 * @property {GUID} msid - msid
 * @property {string} value - The value if there is any, for example the slug that was inputed by the user
 * @property {string} action - slug change etc...
 * @return {LogObject<menusEditorSeoActionParams>} LogObject<menusEditorSeoActionParams>
 */
export function menusEditorSeoAction(params) {
    return { evid: 141, src: 159, endpoint: 'restaurants', params: params };
}
/**
 * A function to create a log object for the 'menusChatAiInstallationFlowMenuInstalled' event (evid: 142)
 *
 * Event description: when the chat AI installed new menu
 *
 * @param {menusChatAiInstallationFlowMenuInstalledParams} params - The parameters for this event
 * @property {string} errorMessage - if there are some errors
 * @property {GUID} flowId - -
 * @property {boolean} isSuccessful - True/false
 * @return {LogObject<menusChatAiInstallationFlowMenuInstalledParams>} LogObject<menusChatAiInstallationFlowMenuInstalledParams>
 */
export function menusChatAiInstallationFlowMenuInstalled(params) {
    return { evid: 142, src: 159, endpoint: 'restaurants', params: params };
}
/**
 * A function to create a log object for the 'tableReservationSettingsClickOnDiscardSpecificSectionChanges' event (evid: 1420)
 *
 * Event description: when the user clicks on discard on the top of the page of each of the sections (table management/availability/notifications/reservation form)
 *
 * @param {tableReservationSettingsClickOnDiscardSpecificSectionChangesParams} params - The parameters for this event
 * @property {string} settingsSection - table_management / online_reservations / reservation_form/ notifications / manual_approval
 * @property {GUID} reservationLocationId - -
 * @property {string} locationGuid - -
 * @property {string} currentToggle - toggle_off/ toggle_on
 * @return {LogObject<tableReservationSettingsClickOnDiscardSpecificSectionChangesParams>} LogObject<tableReservationSettingsClickOnDiscardSpecificSectionChangesParams>
 */
export function tableReservationSettingsClickOnDiscardSpecificSectionChanges(params) {
    return { evid: 1420, src: 159, endpoint: 'restaurants', params: params };
}
/**
 * A function to create a log object for the 'tableReservationSettingsTableManagementSettingsIsLoaded' event (evid: 1422)
 *
 * Event description: when the page of table management loaded has ended. triggered on any tab (table / table combinations)
 *
 * @param {tableReservationSettingsTableManagementSettingsIsLoadedParams} params - The parameters for this event
 * @property {number} numObjects - num of tables in tables tab or num of tables combinations in table combinations tab
 * @property {number} numTablesCombinations - number of table combinations (null if it is tables tab)
 * @property {number} numOfOnlineObjects - only online tables / combinations
 * @property {number} numSeats - total number of seats
 * @property {string} tablesList - json of of [table name: X, min:1, max:5] , [table name:y , min:6 , max: 7 ]...
 * @property {number} numTables - total number of 'regular' tables
 * @property {string} tabName - tabels / table_combinations
 * @property {GUID} reservationLocationId - -
 * @property {GUID} locationId - -
 * @return {LogObject<tableReservationSettingsTableManagementSettingsIsLoadedParams>} LogObject<tableReservationSettingsTableManagementSettingsIsLoadedParams>
 */
export function tableReservationSettingsTableManagementSettingsIsLoaded(params) {
    return { evid: 1422, src: 159, endpoint: 'restaurants', params: params };
}
/**
 * A function to create a log object for the 'tableReservationSettingsClicks' event (evid: 1423)
 *
 * Event description: when the user clicks on buttons inside any settings page
 *
 * @param {tableReservationSettingsClicksParams} params - The parameters for this event
 * @property {string} tabName - if there are no tabs then null
 * @property {GUID} reservationLocationId - -
 * @property {GUID} locationId - -
 * @property {string} actionName - duplicate / delete / online_availability / top_add_table_button / bottom_add_table_button etc.
 * @property {string} pageName - notifications / reservations_form / online_reservations / table_management
 * @property {boolean} isTablet - true/false
 * @return {LogObject<tableReservationSettingsClicksParams>} LogObject<tableReservationSettingsClicksParams>
 */
export function tableReservationSettingsClicks(params) {
    return { evid: 1423, src: 159, endpoint: 'restaurants', params: params };
}
/**
 * A function to create a log object for the 'tableReservationSettingsAvailabilityPageClickSave' event (evid: 1427)
 *
 * Event description: when the user save the availability settings page (event will be send after response from the server)
 *
 * @param {tableReservationSettingsAvailabilityPageClickSaveParams} params - The parameters for this event
 * @property {boolean} manualApproval - true if toggle is on. false if toggle is off
 * @property {string} availabilityHoursList - son - (for example: Sunday: 24h, monday: 09:00-11:30, 14:00-15:30, tuesday:09:00p…)
 * @property {number} partiesMinutes - right now should be 15
 * @property {number} guestsPacing - -
 * @property {string} advancedNoticeNum - -
 * @property {number} partiesPacing - -
 * @property {number} minPartySize - -
 * @property {number} numNewEvents - number of new events at the availability modal
 * @property {number} manualApprovalMinParty - required party size for manual approval
 * @property {number} numExistingEvents - number of events that were existing before this saving
 * @property {string} durationRulesList - json list of the rules
 * @property {GUID} reservationLocationId - -
 * @property {GUID} locationGuid - -
 * @property {string} defaultTime - of reservation duration
 * @property {string} restId - -
 * @property {string} advancedNoticeType - minuted / hours/ days
 * @property {string} scheduleType - opening_hours / custom
 * @property {number} maxPartySize - -
 * @property {string} displayPhoneCheckbox - check/ uncheck
 * @property {number} guestsMinutes - right now should be 15
 * @property {string} pageName - availability_settings
 * @property {boolean} isSuccessful - True/false
 * @property {number} timeSlotInterval - default time slot interval is 15. if the user has changed it this will send the new time interval
 * @property {number} numTurnoverRules - how many rules of turnover are exist at the loading
 * @property {number} maxNotice - max notice time
 * @property {string} maxNoticeType - day/hour etc
 * @property {string} approvalMode - -
 * @return {LogObject<tableReservationSettingsAvailabilityPageClickSaveParams>} LogObject<tableReservationSettingsAvailabilityPageClickSaveParams>
 */
export function tableReservationSettingsAvailabilityPageClickSave(params) {
    return { evid: 1427, src: 159, endpoint: 'restaurants', params: params };
}
/**
 * A function to create a log object for the 'menusChatAiInstallationFlowDeletedMenuDefaultData' event (evid: 143)
 *
 * Event description: when the chat AI Deleted menu deafult data
 *
 * @param {menusChatAiInstallationFlowDeletedMenuDefaultDataParams} params - The parameters for this event
 * @property {string} errorMessage - if there are some errors
 * @property {GUID} flowId - -
 * @property {boolean} isSuccessful - True/false
 * @return {LogObject<menusChatAiInstallationFlowDeletedMenuDefaultDataParams>} LogObject<menusChatAiInstallationFlowDeletedMenuDefaultDataParams>
 */
export function menusChatAiInstallationFlowDeletedMenuDefaultData(params) {
    return { evid: 143, src: 159, endpoint: 'restaurants', params: params };
}
/**
 * A function to create a log object for the 'tableReservationsBoChangeView' event (evid: 1430)
 *
 * Event description: when users click on the floor plan view / back to list view.
 *
 * @param {tableReservationsBoChangeViewParams} params - The parameters for this event
 * @property {string} viewName - floor_plan_view / list_view
 * @property {GUID} reservationLocationId - -
 * @property {string} origin - manage_screen/ shortcut
 * @property {GUID} locationId - -
 * @return {LogObject<tableReservationsBoChangeViewParams>} LogObject<tableReservationsBoChangeViewParams>
 */
export function tableReservationsBoChangeView(params) {
    return { evid: 1430, src: 159, endpoint: 'restaurants', params: params };
}
/**
 * A function to create a log object for the 'tableReservationsClicks' event (evid: 1431)
 *
 * Event description: when users click on any general clicks in the bo.
 *
 * @param {tableReservationsClicksParams} params - The parameters for this event
 * @property {string} tabName - reservation / requests , tables/table_combinations , if there are no tabs on this pagethen null
 * @property {GUID} reservationLocationId - -
 * @property {GUID} locationId - -
 * @property {string} actionName - table / + /- / edit_floor_plan / legend /  duplicate / delete / online_availability / top_add_table_button / bottom_add_table_button etc.
 * @property {string} pageName - -
 * @property {string} placement - button placement name
 * @property {string} experienceId - experience id
 * @property {boolean} isTablet - true/false
 * @return {LogObject<tableReservationsClicksParams>} LogObject<tableReservationsClicksParams>
 */
export function tableReservationsClicks(params) {
    return { evid: 1431, src: 159, endpoint: 'restaurants', params: params };
}
/**
 * A function to create a log object for the 'menusChatAiInstallationFlowCreatedCustomMenu' event (evid: 144)
 *
 * Event description: when the chat AI Created custom menu
 *
 * @param {menusChatAiInstallationFlowCreatedCustomMenuParams} params - The parameters for this event
 * @property {string} errorMessage - if there are some errors
 * @property {GUID} flowId - -
 * @property {boolean} isSuccessful - True/false
 * @property {GUID} menuId - -
 * @return {LogObject<menusChatAiInstallationFlowCreatedCustomMenuParams>} LogObject<menusChatAiInstallationFlowCreatedCustomMenuParams>
 */
export function menusChatAiInstallationFlowCreatedCustomMenu(params) {
    return { evid: 144, src: 159, endpoint: 'restaurants', params: params };
}
/**
 * A function to create a log object for the 'tableReservationSettingsTableManagementClickSave' event (evid: 1443)
 *
 * Event description: click on save changes in table management settings.
 *
 * Please notice the field 'table_management_mode' that determine if the site is using table and in which mode, and then the other fields if relevant.
 *
 * @param {tableReservationSettingsTableManagementClickSaveParams} params - The parameters for this event
 * @property {number} totalSeats - -
 * @property {number} numTables - -
 * @property {number} numNewCombinations - only the new tables from this session
 * @property {GUID} reservationLocationId - -
 * @property {number} numDuplicatedTablesInSession - -
 * @property {string} tablesListActions - json of {action:.. , before:.., after:...,} action can be “change”/”add”/”delete” and before and after are the names of the table +min and max party size
 * @property {GUID} locationId - -
 * @property {number} numNewTables - only the new tables from this session
 * @property {boolean} isSuccessful - true / false
 * @property {number} numCombinations - -
 * @property {number} numOnlineTables - -
 * @property {number} totalNewSeats - only the new tables from this session
 * @property {number} numOnlineCombinations - -
 * @property {string} tableManagementMode - on/ off/ in_house_only
 * @return {LogObject<tableReservationSettingsTableManagementClickSaveParams>} LogObject<tableReservationSettingsTableManagementClickSaveParams>
 */
export function tableReservationSettingsTableManagementClickSave(params) {
    return { evid: 1443, src: 159, endpoint: 'restaurants', params: params };
}
/**
 * A function to create a log object for the 'menusChatAiInstallationFlowCreatedCustomSections' event (evid: 145)
 *
 * Event description: when the chat AI Created custom sections
 *
 * @param {menusChatAiInstallationFlowCreatedCustomSectionsParams} params - The parameters for this event
 * @property {number} numSections - -
 * @property {string} errorMessage - if there are some errors
 * @property {GUID} flowId - -
 * @property {string} sectionsIds - -
 * @property {boolean} isSuccessful - True/false
 * @property {GUID} menuId - -
 * @return {LogObject<menusChatAiInstallationFlowCreatedCustomSectionsParams>} LogObject<menusChatAiInstallationFlowCreatedCustomSectionsParams>
 */
export function menusChatAiInstallationFlowCreatedCustomSections(params) {
    return { evid: 145, src: 159, endpoint: 'restaurants', params: params };
}
/**
 * A function to create a log object for the 'tableReservationCreateReservationSucceed' event (evid: 1450)
 *
 * Event description: create reservation succeeds
 *
 * @param {tableReservationCreateReservationSucceedParams} params - The parameters for this event
 * @property {boolean} isTableOverbooked - true/false (only for user reservations)
 * @property {string} paymentStatus - "UNKNOWN" for live site, "FREE"/"NOT_PAID" for BM during reservation creation, "PAID"/... for BM during reservation edit
 * @property {string} assignTableNames - array of table names in combination
 * @property {GUID} reservationId - -
 * @property {DateTime} reservationStartDate - start time of the reservation
 * @property {string} additionalDetails - json of the additional fields
 * @property {number} numAdditionalDetailsMandatory - -
 * @property {GUID} reservationLocationId - -
 * @property {string} statusBefore - null / RESERVED / HELD / SEATED etc.
 * @property {string} origin - preview_mode/ live_site_mode / business_manager_mode
 * @property {GUID} locationId - -
 * @property {boolean} mailChecked - when the uou is check/uncheck this checkbox
 * @property {GUID} contactId - -
 * @property {number} numGuestDetailEmpty - -
 * @property {DateTime} creationDate - creation time of the event
 * @property {number} numAdditionalDetailsEmpty - -
 * @property {boolean} teamMessageEmpty - True if its empty and false if not
 * @property {string} reservationType - reservation/walk_in
 * @property {number} numAdditionalDetailsFull - -
 * @property {DateTime} reservationDuration - the duration of the reservation - in A milli second
 * @property {string} statusCurrent - RESERVED / HELD / SEATED / PAYMENT_PENDING etc.
 * @property {string} assignTableIds - array
 * @property {number} partySize - -
 * @property {number} numGuestDetailFull - -
 * @property {string} teamMessage - json of the text
 * @property {string} saveType - created/edit
 * @property {boolean} isCardTokenization - is reservation use card Tokenization
 * @property {string} referer - Google maps/Google profile ...
 * @property {string} prepaymentType - per gurst/per party
 * @property {string} experienceId - experience id
 * @return {LogObject<tableReservationCreateReservationSucceedParams>} LogObject<tableReservationCreateReservationSucceedParams>
 */
export function tableReservationCreateReservationSucceed(params) {
    return { evid: 1450, src: 159, endpoint: 'restaurants', params: params };
}
/**
 * A function to create a log object for the 'tableReservationSettingsPageToggleAction' event (evid: 1451)
 *
 * Event description: when the user clicks on the toggle (toggle - if online reservations are on)
 * action type - what is the toggle status after the user action
 * last toggle state - the toggle status before the user action
 *
 * @param {tableReservationSettingsPageToggleActionParams} params - The parameters for this event
 * @property {string} previousToggleState - toggle_off/ toggle_on
 * @property {GUID} reservationLocationId - -
 * @property {string} actionType - toggle_off/ toggle_on
 * @property {GUID} locationId - -
 * @return {LogObject<tableReservationSettingsPageToggleActionParams>} LogObject<tableReservationSettingsPageToggleActionParams>
 */
export function tableReservationSettingsPageToggleAction(params) {
    return { evid: 1451, src: 159, endpoint: 'restaurants', params: params };
}
/**
 * A function to create a log object for the 'tableReservationSettingsReservationFormClickSave' event (evid: 1453)
 *
 * Event description: click on save changes on reservation form settings, event will be send after a response from the server.
 *
 * @param {tableReservationSettingsReservationFormClickSaveParams} params - The parameters for this event
 * @property {string} emailMarketingCheckByDeafult - checked / unchecked
 * @property {string} privacyPolicyType - text/url/null
 * @property {string} customFieldsText - json with the text and +mandatory if it is
 * @property {string} customMessageToggle - toggle_on / toggle_off (value after the user clicked)
 * @property {string} customMessageText - json
 * @property {string} emailMandatoryToggle - toggle_on / toggle_off (value after the user clicked)
 * @property {number} numMandatoryFileds - -
 * @property {string} reservationPoliciesToggle - toggle_on / toggle_off (value after the user clicked)
 * @property {GUID} reservationLocationId - -
 * @property {number} numCustomFields - -
 * @property {string} privacyPolicy - checked / unchecked
 * @property {string} lastNameMandatoryToggle - toggle_on / toggle_off (value after the user clicked)
 * @property {string} termsCondType - text/url/null
 * @property {GUID} locationId - -
 * @property {string} termsAndConditionsText - json of the text
 * @property {string} emailMarketingCheckboxToggle - toggle_on / toggle_off (value after the user clicked)
 * @property {string} privacyPolicyText - json of the text
 * @property {boolean} isSuccessful - true / false
 * @property {string} policiesTermsCond - checked / unchecked
 * @return {LogObject<tableReservationSettingsReservationFormClickSaveParams>} LogObject<tableReservationSettingsReservationFormClickSaveParams>
 */
export function tableReservationSettingsReservationFormClickSave(params) {
    return { evid: 1453, src: 159, endpoint: 'restaurants', params: params };
}
/**
 * A function to create a log object for the 'tableReservationsCancelationSucceed' event (evid: 1454)
 *
 * Event description: reservation cancelation succeed by UoU
 *
 * @param {tableReservationsCancelationSucceedParams} params - The parameters for this event
 * @property {GUID} reservationId - -
 * @property {DateTime} datetime - -
 * @property {GUID} reservationLocationId - -
 * @property {string} reservationStatus - HELD / REQUESTED / RESERVED
 * @property {string} origin - preview / live_site
 * @property {GUID} locationId - -
 * @property {number} partySize - -
 * @return {LogObject<tableReservationsCancelationSucceedParams>} LogObject<tableReservationsCancelationSucceedParams>
 */
export function tableReservationsCancelationSucceed(params) {
    return { evid: 1454, src: 159, endpoint: 'restaurants', params: params };
}
/**
 * A function to create a log object for the 'tableReservationsClickOnReservationsAttribute' event (evid: 1455)
 *
 * Event description: UoU clicked on any of the reservation fields
 *
 * @param {tableReservationsClickOnReservationsAttributeParams} params - The parameters for this event
 * @property {GUID} reservationLocationId - -
 * @property {string} fieldName - time / date / party_size / location
 * @property {string} origin - live_site_mode / preview_mode
 * @property {GUID} locationId - -
 * @property {boolean} isAddOn - true / false
 * @property {string} type - for example -page/widget/ mobile_section
 * @property {boolean} isMultiLocation - true if the site has more than one location
 * @property {string} experienceId - experience id
 * @property {string} value - selected value
 * @return {LogObject<tableReservationsClickOnReservationsAttributeParams>} LogObject<tableReservationsClickOnReservationsAttributeParams>
 */
export function tableReservationsClickOnReservationsAttribute(params) {
    return { evid: 1455, src: 159, endpoint: 'restaurants', params: params };
}
/**
 * A function to create a log object for the 'tableReservationsBoReservationsModalOpened' event (evid: 1456)
 *
 * Event description: modal of creating reservations is opened (loaded)
 *
 * @param {tableReservationsBoReservationsModalOpenedParams} params - The parameters for this event
 * @property {string} modalType - reservation/request
 * @property {GUID} reservationId - null if there is no reservation id
 * @property {GUID} reservationLocationId - -
 * @property {string} viewType - floor_plan_view / reservations_list_view
 * @property {GUID} locationId - -
 * @property {string} reservationType - reservation / walk_in
 * @property {string} type - create / edit
 * @property {string} referralSource - source the tab was opened from
 * @return {LogObject<tableReservationsBoReservationsModalOpenedParams>} LogObject<tableReservationsBoReservationsModalOpenedParams>
 */
export function tableReservationsBoReservationsModalOpened(params) {
    return { evid: 1456, src: 159, endpoint: 'restaurants', params: params };
}
/**
 * A function to create a log object for the 'restaurantsTableReservationsSettingsTableManagementClickOnTabWithoutSavingModal' event (evid: 1459)
 *
 * Event description: when the modal is loaded when user tries to move to another tab after he made changes and didn't save
 *
 * @param {restaurantsTableReservationsSettingsTableManagementClickOnTabWithoutSavingModalParams} params - The parameters for this event
 * @property {string} tabName - -
 * @property {GUID} reservationLocationId - -
 * @property {GUID} locationId - -
 * @return {LogObject<restaurantsTableReservationsSettingsTableManagementClickOnTabWithoutSavingModalParams>} LogObject<restaurantsTableReservationsSettingsTableManagementClickOnTabWithoutSavingModalParams>
 */
export function restaurantsTableReservationsSettingsTableManagementClickOnTabWithoutSavingModal(params) {
    return { evid: 1459, src: 159, endpoint: 'restaurants', params: params };
}
/**
 * A function to create a log object for the 'menusChatAiInstallationFlowCreatedCustomItems' event (evid: 146)
 *
 * Event description: when the chat AI Created custom items
 *
 * @param {menusChatAiInstallationFlowCreatedCustomItemsParams} params - The parameters for this event
 * @property {number} numSections - -
 * @property {string} errorMessage - if there are some errors
 * @property {GUID} flowId - -
 * @property {number} numItems - -
 * @property {boolean} isSuccessful - True/false
 * @property {GUID} menuId - -
 * @property {string} itemsIds - -
 * @return {LogObject<menusChatAiInstallationFlowCreatedCustomItemsParams>} LogObject<menusChatAiInstallationFlowCreatedCustomItemsParams>
 */
export function menusChatAiInstallationFlowCreatedCustomItems(params) {
    return { evid: 146, src: 159, endpoint: 'restaurants', params: params };
}
/**
 * A function to create a log object for the 'restaurantsTableReservationsSettingsTableManagementTableObjectCreated' event (evid: 1460)
 *
 * Event description: when the user creases new object of table/ table combination. triggered after a response from the server if successful or not.
 *
 * @param {restaurantsTableReservationsSettingsTableManagementTableObjectCreatedParams} params - The parameters for this event
 * @property {number} minSeats - -
 * @property {GUID} reservationLocationId - -
 * @property {string} viewType - floor_plan_editor / table_management
 * @property {boolean} isAvailableOnline - true / false
 * @property {GUID} locationId - -
 * @property {string} objectId - tabel id or combination id
 * @property {string} type - tables / tables_combination
 * @property {boolean} isSuccessful - true / false
 * @property {number} maxSeats - -
 * @property {number} numTablesInCombination - number of tables inside the combination
 * @property {string} objectName - table / combination name
 * @property {boolean} isTablet - true/false
 * @return {LogObject<restaurantsTableReservationsSettingsTableManagementTableObjectCreatedParams>} LogObject<restaurantsTableReservationsSettingsTableManagementTableObjectCreatedParams>
 */
export function restaurantsTableReservationsSettingsTableManagementTableObjectCreated(params) {
    return { evid: 1460, src: 159, endpoint: 'restaurants', params: params };
}
/**
 * A function to create a log object for the 'menusImportMenusActions' event (evid: 147)
 *
 * Event description: when a user clicks on one of the buttons in the import menu from old menus app flow.
 *
 * @param {menusImportMenusActionsParams} params - The parameters for this event
 * @property {string} origin - if the import still in progress - 'import menus' , if there was an error - 'import menus error'
 * @property {string} pageName - -
 * @property {string} action - the specific action was made
 * @property {string} modalState - indicates the step of the modal in the flow
 * @return {LogObject<menusImportMenusActionsParams>} LogObject<menusImportMenusActionsParams>
 */
export function menusImportMenusActions(params) {
    return { evid: 147, src: 159, endpoint: 'restaurants', params: params };
}
/**
 * A function to create a log object for the 'menusShowHideItemAction' event (evid: 148)
 *
 * Event description: User clicked on show or hide item
 *
 * @param {menusShowHideItemActionParams} params - The parameters for this event
 * @property {string} name - item name
 * @property {string} origin - a button/area from where the action originated from.
 * @property {string} errorDescription - text that describes the error reason
 * @property {GUID} sectionId - Section ID. Unique id in a site level
 * @property {GUID} itemId - Item ID. Unique id in a site level
 * @property {string} pageName - -
 * @property {boolean} isSharedItem - -
 * @property {boolean} isSuccessful - states if the save was successful.
 * @property {string} action - show/hide
 * @return {LogObject<menusShowHideItemActionParams>} LogObject<menusShowHideItemActionParams>
 */
export function menusShowHideItemAction(params) {
    return { evid: 148, src: 159, endpoint: 'restaurants', params: params };
}
/**
 * A function to create a log object for the 'restaurantsEditorPanelEditAction' event (evid: 15)
 *
 * Event description: User makes a change in the design of a restaurants editor widget, this event sends data of the full path of the desired change in design
 *
 * @param {restaurantsEditorPanelEditActionParams} params - The parameters for this event
 * @property {string} widgetId - an id for the specific widget
 * @property {string} lastLevel - The last and most detailed level , i.e : color picker/ fonts/themes/etc…
 * If there is only a first level then the last and first level will send the same value.
 * @property {string} pageId - The id of the site builder page the action occurred in
 * @property {string} widgetName - widget_name
 * @property {string} panelName - panel name
 * @property {string} sitePageName - Name of the page inside the live site/editor. This is something the user can edit
 * @property {string} firstLevel - The first navigation level, i.e : menu title/ section title/ labels/ etc…
 * @property {string} widgetInstanceId - Id of the widget inside editor or live site. This id is supposed to be unique for a site and widget
 * @property {GUID} msid - msid
 * @property {string} value - most commonly paired with a field column, and the value is the acutal value related to that field
 * @property {string} fullPath - The complete level path for example : fill color & opacity, background, color picker
 * @property {string} product - the specific product this event is related to: menus/table reservations/orders etc
 * @return {LogObject<restaurantsEditorPanelEditActionParams>} LogObject<restaurantsEditorPanelEditActionParams>
 */
export function restaurantsEditorPanelEditAction(params) {
    return { evid: 15, src: 159, endpoint: 'restaurants', params: params };
}
/**
 * A function to create a log object for the 'tableReservationsUouStartOfReservationFunnelClickOnFindATable' event (evid: 1506)
 *
 * Event description: clicks of UoU in the beginning of the funnel
 *
 * @param {tableReservationsUouStartOfReservationFunnelClickOnFindATableParams} params - The parameters for this event
 * @property {DateTime} datetime - -
 * @property {GUID} reservationLocationId - -
 * @property {string} origin - previe_mode/live_site_mode
 * @property {GUID} locationId - -
 * @property {boolean} isAddOn - true if its a click from the add on and false if not
 * @property {number} partySize - -
 * @property {boolean} isMultiLocation - consider only live site available locations
 * @return {LogObject<tableReservationsUouStartOfReservationFunnelClickOnFindATableParams>} LogObject<tableReservationsUouStartOfReservationFunnelClickOnFindATableParams>
 */
export function tableReservationsUouStartOfReservationFunnelClickOnFindATable(params) {
    return { evid: 1506, src: 159, endpoint: 'restaurants', params: params };
}
/**
 * A function to create a log object for the 'menusModifierGroupModalIsOpened' event (evid: 151)
 *
 * Event description: Modifier Group modal is opened
 *
 * @param {menusModifierGroupModalIsOpenedParams} params - The parameters for this event
 * @property {string} name - name of the modifier group
 * @property {boolean} isMandatory - true/false
 * @property {string} flowType - which flow type the modal/panel is at. New/Edit/Duplicate etc
 * @property {number} maxSelections - max_selections
 * @property {string} errorType - The type of the error - validtion/ server/ etc...
 * @property {GUID} id - Modifier group id
 * @property {string} modifierGroupId - only if it’s not null (in the updates)
 * @property {string} origin - a button/area from where the action originated from. for example an origin of a modal load can be a specific button that triggered it's load
 * @property {string} modifiers - json array of modifiers
 * @property {number} minSelections - min_selections
 * @property {string} errorDescription - text that describes the error reason
 *
 * @property {GUID} itemId - Item ID of the item the modifier were saved in
 * @property {string} pageName - name of the page
 * @property {number} numPreselectedModifiers - num preselected modifiers
 * @property {string} type - optional/mandatory sinces Nov23. before - SINGLE_SELECT/ MULTI_SELECT/UNSPECIFIED_RULE_TYPE
 * @property {boolean} isSuccessful - states if the save was succesful. if not there sould be an error description column
 * @property {boolean} isNoLimit - true/false
 * @property {number} maxChoices - maximum number of extras the customer can choose. Relevant to mulitSelection only
 * @return {LogObject<menusModifierGroupModalIsOpenedParams>} LogObject<menusModifierGroupModalIsOpenedParams>
 */
export function menusModifierGroupModalIsOpened(params) {
    return { evid: 151, src: 159, endpoint: 'restaurants', params: params };
}
/**
 * A function to create a log object for the 'tableReservationsUouClickOnCompleteReservation' event (evid: 1515)
 *
 * Event description: click on complete reservation - in order to make sure that reservations was done use condition - "num_invalid_fields = 0"
 *
 * @param {tableReservationsUouClickOnCompleteReservationParams} params - The parameters for this event
 * @property {string} mailCheckbox - check/uncheck
 * @property {GUID} reservationLocationId - -
 * @property {string} origin - previe_mode/live_site_mode
 * @property {GUID} locationId - -
 * @property {number} numInvaldFields - -
 * @property {string} contactId - -
 * @property {number} partySize - -
 * @property {number} numValidFields - -
 * @property {DateTime} dateTimeValue - of the reservation
 * @property {string} areaCode - -
 * @return {LogObject<tableReservationsUouClickOnCompleteReservationParams>} LogObject<tableReservationsUouClickOnCompleteReservationParams>
 */
export function tableReservationsUouClickOnCompleteReservation(params) {
    return { evid: 1515, src: 159, endpoint: 'restaurants', params: params };
}
/**
 * A function to create a log object for the 'menusItemModifierGroupsModalSaveReorder' event (evid: 152)
 *
 * Event description: when the user changes the order of the modifier groups in the item
 *
 * @param {menusItemModifierGroupsModalSaveReorderParams} params - The parameters for this event
 * @property {string} idsOrderListAfterChange - list of ids
 * @property {number} numModifierGroups - -
 * @property {string} orderListBeforeChange - list of modifier groups names
 * @property {string} orderListAfterChange - list of modifier groups names
 * @property {string} idsOrderListBeforeChange - list of ids
 * @return {LogObject<menusItemModifierGroupsModalSaveReorderParams>} LogObject<menusItemModifierGroupsModalSaveReorderParams>
 */
export function menusItemModifierGroupsModalSaveReorder(params) {
    return { evid: 152, src: 159, endpoint: 'restaurants', params: params };
}
/**
 * A function to create a log object for the 'tableReservationsUouClickOnReserveNow' event (evid: 1524)
 *
 * Event description: in the reservations page, event is triggered when UoU click on “reserve now” button that triggered the next page / or in members app on the requested time
 *
 * @param {tableReservationsUouClickOnReserveNowParams} params - The parameters for this event
 * @property {GUID} reservationLocationId - -
 * @property {DateTime} requestedDate - timestamp contains date and time.
 * @property {string} origin - previe_mode/live_site_mode
 * @property {GUID} locationId - -
 * @property {number} partySize - -
 * @return {LogObject<tableReservationsUouClickOnReserveNowParams>} LogObject<tableReservationsUouClickOnReserveNowParams>
 */
export function tableReservationsUouClickOnReserveNow(params) {
    return { evid: 1524, src: 159, endpoint: 'restaurants', params: params };
}
/**
 * A function to create a log object for the 'tableReservationsUouStartOfReservationFunnelReservationPageWidgetIsLoaded' event (evid: 1525)
 *
 * Event description: when the UoU see the reservations page/widget
 *
 * @param {tableReservationsUouStartOfReservationFunnelReservationPageWidgetIsLoadedParams} params - The parameters for this event
 * @property {string} origin - previe_mode/live_site_mode
 * @property {boolean} isAddOn - true if its a click from the add on and false if not. for mobile - null
 * @property {string} type - page/widget/ mobile_section
 * @property {string} experienceId - experience id
 * @property {string} pageName - reservations/experiences
 * @return {LogObject<tableReservationsUouStartOfReservationFunnelReservationPageWidgetIsLoadedParams>} LogObject<tableReservationsUouStartOfReservationFunnelReservationPageWidgetIsLoadedParams>
 */
export function tableReservationsUouStartOfReservationFunnelReservationPageWidgetIsLoaded(params) {
    return { evid: 1525, src: 159, endpoint: 'restaurants', params: params };
}
/**
 * A function to create a log object for the 'tableReservationsUouClickOnChangeReservationDetails' event (evid: 1526)
 *
 * Event description: after UoU pressed on reserve, he pressed on the 'change' the reservation details option
 *
 * @param {tableReservationsUouClickOnChangeReservationDetailsParams} params - The parameters for this event
 * @property {GUID} reservationId - -
 * @property {GUID} reservationLocationId - -
 * @property {string} reservationStatus - 'HELD'- reservation | 'null' - request
 * @property {string} origin - preview / live_site
 * @property {GUID} locationId - -
 * @return {LogObject<tableReservationsUouClickOnChangeReservationDetailsParams>} LogObject<tableReservationsUouClickOnChangeReservationDetailsParams>
 */
export function tableReservationsUouClickOnChangeReservationDetails(params) {
    return { evid: 1526, src: 159, endpoint: 'restaurants', params: params };
}
/**
 * A function to create a log object for the 'tableReservationsUouClickOnAddToCalendar' event (evid: 1527)
 *
 * Event description: when UoU pressed on add reservation to calendar, after response from the server if the save was successful
 *
 * @param {tableReservationsUouClickOnAddToCalendarParams} params - The parameters for this event
 * @property {GUID} reservationId - -
 * @property {GUID} reservationLocationId - -
 * @property {string} origin - preview / live_site_mode / spaces_app / branded_app / dine
 * @property {GUID} locationId - -
 * @property {boolean} isSuccessful - true if the reservation was saved in calendar successfully
 * @return {LogObject<tableReservationsUouClickOnAddToCalendarParams>} LogObject<tableReservationsUouClickOnAddToCalendarParams>
 */
export function tableReservationsUouClickOnAddToCalendar(params) {
    return { evid: 1527, src: 159, endpoint: 'restaurants', params: params };
}
/**
 * A function to create a log object for the 'tableReservationsUouClickOnRestaurantDetailsLink' event (evid: 1528)
 *
 * Event description: after the UoU has completed the reservation, fires when he clicks on one of the restaurant details links
 *
 * @param {tableReservationsUouClickOnRestaurantDetailsLinkParams} params - The parameters for this event
 * @property {GUID} reservationId - -
 * @property {GUID} reservationLocationId - -
 * @property {string} origin - preview / live_site_mode / spaces_app / branded_app / dine
 * @property {GUID} locationId - -
 * @property {string} action - website / phone / location
 * @return {LogObject<tableReservationsUouClickOnRestaurantDetailsLinkParams>} LogObject<tableReservationsUouClickOnRestaurantDetailsLinkParams>
 */
export function tableReservationsUouClickOnRestaurantDetailsLink(params) {
    return { evid: 1528, src: 159, endpoint: 'restaurants', params: params };
}
/**
 * A function to create a log object for the 'menusItemPageAddExistingModifierGroupToItem' event (evid: 153)
 *
 * Event description: when user use the reusable feature and add existing modifier group to an item
 *
 * @param {menusItemPageAddExistingModifierGroupToItemParams} params - The parameters for this event
 * @property {number} numModifierGroupsAdded - -
 * @property {string} itemId - -
 * @property {string} modifierGroupList - -
 * @property {string} itemName - -
 * @property {string} modifierGroupIds - -
 * @return {LogObject<menusItemPageAddExistingModifierGroupToItemParams>} LogObject<menusItemPageAddExistingModifierGroupToItemParams>
 */
export function menusItemPageAddExistingModifierGroupToItem(params) {
    return { evid: 153, src: 159, endpoint: 'restaurants', params: params };
}
/**
 * A function to create a log object for the 'menusEditorMenuNavigationPanelAction' event (evid: 154)
 *
 * Event description: User clicked on a button inside the choose menu navigation panel that made a difference in the menu navigation design.
 *
 * @param {menusEditorMenuNavigationPanelActionParams} params - The parameters for this event
 * @property {string} widgetId - -
 * @property {string} pageId - -
 * @property {string} widgetName - Menus
 * @property {string} sitePageName - -
 * @property {string} widgetInstanceId - -
 * @property {string} action - Tabs / Dropdown
 * @return {LogObject<menusEditorMenuNavigationPanelActionParams>} LogObject<menusEditorMenuNavigationPanelActionParams>
 */
export function menusEditorMenuNavigationPanelAction(params) {
    return { evid: 154, src: 159, endpoint: 'restaurants', params: params };
}
/**
 * A function to create a log object for the 'restaurantsModalLoad' event (evid: 16)
 *
 * Event description: A modal loaded inside one of restaurants' apps
 *
 * @param {restaurantsModalLoadParams} params - The parameters for this event
 * @property {string} origin - a button/area from where the action originated from. for example an origin of a modal load can be a specific button that triggered it's load
 * @property {string} pageName - name of the page the modal loaded in
 * @property {string} refferal_info - additional data that you want to send and don't have a field for that
 * @property {string} modalName - modal name, naming convention: product.modal-name for example, menus.delete-section
 * @property {string} product - the specific product this event is related to: menus/table reservations/orders etc
 * @property {GUID} locationId - locationId
 * @property {boolean} isDeletedLocation - isDeletedLocation
 * @property {string} operationStatus - hidden/visible.
 * the status before the status update approval
 * @property {string} operationId - operationId
 * @property {GUID} operationGroup - operationGroup
 * @property {boolean} isDefaultLocation - isDefaultLocation
 * @return {LogObject<restaurantsModalLoadParams>} LogObject<restaurantsModalLoadParams>
 */
export function restaurantsModalLoad(params) {
    return { evid: 16, src: 159, endpoint: 'restaurants', params: params };
}
/**
 * A function to create a log object for the 'restaurantsModalClose' event (evid: 17)
 *
 * Event description: A user closed one of restaurants modals
 *
 * @param {restaurantsModalCloseParams} params - The parameters for this event
 * @property {string} origin - a button/area from where the action originated from. for example an origin of a modal load can be a specific button that triggered it's load
 * @property {string} pageName - name of the page the modal loaded in
 * @property {string} modalName - modal name, naming convention: product.modal-name for example, menus.delete-section
 * @property {string} product - the specific product this event is related to: menus/table reservations/orders etc
 * @return {LogObject<restaurantsModalCloseParams>} LogObject<restaurantsModalCloseParams>
 */
export function restaurantsModalClose(params) {
    return { evid: 17, src: 159, endpoint: 'restaurants', params: params };
}
/**
 * A function to create a log object for the 'restaurantsToastLoad' event (evid: 18)
 *
 * Event description: Toast Loaded inside one of restaurants apps (BM/Owners app)
 *
 * @param {restaurantsToastLoadParams} params - The parameters for this event
 * @property {string} toastColor - color of the toast
 * @property {string} toastText - the text that is sent inside the toast
 * @property {boolean} hasCTA - states if the toast contains a CTA button inside of it
 * @property {string} pageName - name of the page
 * @property {string} product - the specific product this event is related to: menus/table reservations/orders etc
 * @property {string} trigger - what triggered the action. for example an error the triggered a toast load
 * @return {LogObject<restaurantsToastLoadParams>} LogObject<restaurantsToastLoadParams>
 */
export function restaurantsToastLoad(params) {
    return { evid: 18, src: 159, endpoint: 'restaurants', params: params };
}
/**
 * A function to create a log object for the 'restaurantsToastClose' event (evid: 19)
 *
 * Event description: User closed a Toast inside one of restaurants apps (BM/Owners app) To trigger this event the user must press actively on a button that closes the toast. It will not fire when the toast closes automatically
 *
 * @param {restaurantsToastCloseParams} params - The parameters for this event
 * @property {string} toastColor - color of the toast
 * @property {string} toastText - the text that is sent inside the toast
 * @property {boolean} hasCTA - states if the toast contains a CTA button inside of it
 * @property {string} pageName - name of the page
 * @property {string} product - the specific product this event is related to: menus/table reservations/orders etc
 * @property {string} trigger - what triggered the action. for example an error the triggered a toast load
 * @return {LogObject<restaurantsToastCloseParams>} LogObject<restaurantsToastCloseParams>
 */
export function restaurantsToastClose(params) {
    return { evid: 19, src: 159, endpoint: 'restaurants', params: params };
}
/**
 * A function to create a log object for the 'restaurantsToastCtaClick' event (evid: 20)
 *
 * Event description: User clicked on a CTA button placed inside a banner in a restaurants' page. Not all banners containg a CTA button
 *
 * @param {restaurantsToastCtaClickParams} params - The parameters for this event
 * @property {string} toastColor - color of the toast
 * @property {string} ctaText - the text that is written on the cta button
 * @property {string} toastText - the text that is sent inside the toast
 * @property {string} pageName - name of the page
 * @property {string} product - the specific product this event is related to: menus/table reservations/orders etc
 * @property {string} trigger - what triggered the action. for example an error the triggered a toast load
 * @property {GUID} locationId - locationId
 * @return {LogObject<restaurantsToastCtaClickParams>} LogObject<restaurantsToastCtaClickParams>
 */
export function restaurantsToastCtaClick(params) {
    return { evid: 20, src: 159, endpoint: 'restaurants', params: params };
}
/**
 * A function to create a log object for the 'thermalPrintingPageLoad' event (evid: 2001)
 *
 * Event description: A screen related to thermal printing  was loaded
 *
 * @param {thermalPrintingPageLoadParams} params - The parameters for this event
 * @property {boolean} isEmptyState - If the page is in empty state
 * @property {GUID} triggerAppId - The app id of the app that triggered this page load
 * @property {string} origin - a button/area from where the action originated from. for example an origin of a modal load can be a specific button that triggered it's load
 * @property {string} triggerApp - The name of the app that triggered the page load
 * @property {string} pageName - name of the page the modal loaded in
 * @property {string} extraParams - A json for extra parameters that were not defined. Not a necessary field
 * @return {LogObject<thermalPrintingPageLoadParams>} LogObject<thermalPrintingPageLoadParams>
 */
export function thermalPrintingPageLoad(params) {
    return { evid: 2001, src: 159, endpoint: 'restaurants', params: params };
}
/**
 * A function to create a log object for the 'thermalPrintingSetupScreensNavigationClicks' event (evid: 2002)
 *
 * Event description: User clicked on a navigation action inside the setup process (back,next,done,etc)
 *
 * @param {thermalPrintingSetupScreensNavigationClicksParams} params - The parameters for this event
 * @property {string} buttonType - close,next/back/done/etc...
 * @property {GUID} triggerAppId - The app id of the app that triggered this page load
 * @property {string} destinationPageName - The name of the page the user is directed to from the button action
 * @property {string} triggerApp - The name of the app that triggered the page load
 * @property {string} pageName - name of the page the modal loaded in
 * @property {string} extraParams - A json for extra parameters that were not defined. Not a necessary field
 * @return {LogObject<thermalPrintingSetupScreensNavigationClicksParams>} LogObject<thermalPrintingSetupScreensNavigationClicksParams>
 */
export function thermalPrintingSetupScreensNavigationClicks(params) {
    return { evid: 2002, src: 159, endpoint: 'restaurants', params: params };
}
/**
 * A function to create a log object for the 'thermalPrintingSetupPickPrinterClick' event (evid: 2003)
 *
 * Event description: User clicked on a printer in the list of available printers
 *
 * @param {thermalPrintingSetupPickPrinterClickParams} params - The parameters for this event
 * @property {string} printerId - The id of the printer that was chosen
 * @property {string} printerModel - The full printer model name
 * @property {number} numOfAvailablePrinters - number of available printers
 * @property {string} extraParams - A json for extra parameters that were not defined. Not a necessary field
 * @property {string} printerBrand - Brand of the printer chosen
 * @property {string} connectionType - bluetooth/wifi
 * @return {LogObject<thermalPrintingSetupPickPrinterClickParams>} LogObject<thermalPrintingSetupPickPrinterClickParams>
 */
export function thermalPrintingSetupPickPrinterClick(params) {
    return { evid: 2003, src: 159, endpoint: 'restaurants', params: params };
}
/**
 * A function to create a log object for the 'thermalPrintingSetupPrinterConnection' event (evid: 2004)
 *
 * Event description: After the user chooses the printer it wants to connect and presses next, this event fires after getting the response from the printer if it succeeded to connect
 *
 * @param {thermalPrintingSetupPrinterConnectionParams} params - The parameters for this event
 * @property {string} printerId - The id of the printer that was chosen
 * @property {string} printerModel - The full printer model name
 * @property {string} errorType - type of error: server/printer/etc...
 * @property {string} errorDescription - if there is a more detailed explanation to the error, it will appear here
 * @property {boolean} isSuccessful - did the connection succeed
 * @property {string} extraParams - A json for extra parameters that were not defined. Not a necessary field
 * @property {string} printerBrand - Brand of the printer chosen
 * @property {string} connectionType - bluetooth/wifi
 * @property {string} origin - stores/rest
 * @return {LogObject<thermalPrintingSetupPrinterConnectionParams>} LogObject<thermalPrintingSetupPrinterConnectionParams>
 */
export function thermalPrintingSetupPrinterConnection(params) {
    return { evid: 2004, src: 159, endpoint: 'restaurants', params: params };
}
/**
 * A function to create a log object for the 'thermalPrintingPrintTestOrder' event (evid: 2005)
 *
 * Event description: User tried to make a test print
 *
 * @param {thermalPrintingPrintTestOrderParams} params - The parameters for this event
 * @property {string} printerId - The id of the printer that was chosen
 * @property {string} printerModel - The full printer model name
 * @property {string} triggerAppId - the app id of the app that this action occurred in
 * @property {string} errorType - type of error: server/printer/etc...
 * @property {string} origin - The origin of the click, for example 'finish setup'
 * @property {string} errorDescription - if there is a more detailed explanation to the error, it will appear here
 * @property {string} triggerApp - the app name of the app that this action occurred in
 * @property {string} pageName - The screen that the action occured in
 * @property {boolean} isSuccessful - did the print succeed
 * @property {string} extraParams - A json for extra parameters that were not defined. Not a necessary field
 * @property {string} printerBrand - Brand of the printer chosen
 * @property {string} connectionType - bluetooth/wifi
 * @return {LogObject<thermalPrintingPrintTestOrderParams>} LogObject<thermalPrintingPrintTestOrderParams>
 */
export function thermalPrintingPrintTestOrder(params) {
    return { evid: 2005, src: 159, endpoint: 'restaurants', params: params };
}
/**
 * A function to create a log object for the 'thermalPrintingPrint' event (evid: 2006)
 *
 * Event description: Print was made, from all sources (except for test prints)
 *
 * @param {thermalPrintingPrintParams} params - The parameters for this event
 * @property {string} printerId - The id of the printer that was chosen
 * @property {string} printerModel - The full printer model name
 * @property {string} errorType - type of error: server/printer/etc...
 * @property {string} id - This id should be paired with the "type" field
 * @property {string} errorDescription - if there is a more detailed explanation to the error, it will appear here
 * @property {string} type - The type of object being printed. For example: "order"
 * @property {string} appId - app id of the the app that triggered the print
 * @property {boolean} isSuccessful - did the print succeed
 * @property {string} extraParams - A json for extra parameters that were not defined. Not a necessary field. For example for restaurants there can be printType in the extra params that says if it was manually or auto printed
 * @property {string} printerBrand - Brand of the printer chosen
 * @property {string} connectionType - bluetooth/wifi
 * @property {string} origin - stores/rest
 * @return {LogObject<thermalPrintingPrintParams>} LogObject<thermalPrintingPrintParams>
 */
export function thermalPrintingPrint(params) {
    return { evid: 2006, src: 159, endpoint: 'restaurants', params: params };
}
/**
 * A function to create a log object for the 'thermalPrintingKbLinkClick' event (evid: 2007)
 *
 * Event description: User clicked on a link to one of the thermal printing KBs
 *
 * @param {thermalPrintingKbLinkClickParams} params - The parameters for this event
 * @property {string} destinationUrl - The url of the KB that the user is being directed to
 * @property {string} origin - the area from which the KB was triggered from
 * @property {string} pageName - name of the screen the link appeared in
 * @property {GUID} appId - app id of an app that is associated with this KB, for example restaurants' orders app id can appear here if the KB is related to it
 * @property {string} extraParams - A json for extra parameters that were not defined. Not a necessary field
 * @return {LogObject<thermalPrintingKbLinkClickParams>} LogObject<thermalPrintingKbLinkClickParams>
 */
export function thermalPrintingKbLinkClick(params) {
    return { evid: 2007, src: 159, endpoint: 'restaurants', params: params };
}
/**
 * A function to create a log object for the 'thermalPrintingPrinterUnpair' event (evid: 2008)
 *
 * Event description: The user manually unpaired his printer, when combined with evid = 2004 we can check whether there is a printer connected
 *
 * @param {thermalPrintingPrinterUnpairParams} params - The parameters for this event
 * @property {string} printerId - The id of the printer that was chosen
 * @property {string} printerModel - The full printer model name
 * @property {string} extraParams - A json for extra parameters that were not defined. Not a necessary field
 * @property {string} printerBrand - Brand of the printer chosen
 * @property {string} connectionType - bluetooth/wifi
 * @return {LogObject<thermalPrintingPrinterUnpairParams>} LogObject<thermalPrintingPrinterUnpairParams>
 */
export function thermalPrintingPrinterUnpair(params) {
    return { evid: 2008, src: 159, endpoint: 'restaurants', params: params };
}
/**
 * A function to create a log object for the 'menusCloseAddInlineComponent' event (evid: 2011)
 *
 * Event description: User Closed a side panel inside one of menus app in the business manager.Notice that when a user tries to close the panel while in the middle of editing it opens a 'discard changes modal'. When this happens, this event should not fire! Only once the modal closes this event fires, and if it occures after the user clicked on discard changes, then the origin will be 'discard changes modal'. These can also happen in the owners app parallel screens
 *
 * @param {menusCloseAddInlineComponentParams} params - The parameters for this event
 * @property {string} panelName - panel name
 * @property {string} origin - a button/area from where the action originated from. for example an origin of a modal load can be a specific button that triggered it's load
 * @property {string} pageName - name of the page
 * @return {LogObject<menusCloseAddInlineComponentParams>} LogObject<menusCloseAddInlineComponentParams>
 */
export function menusCloseAddInlineComponent(params) {
    return { evid: 2011, src: 159, endpoint: 'restaurants', params: params };
}
/**
 * A function to create a log object for the 'restaurantsMoreButtonClick' event (evid: 21)
 *
 * Event description: User Clicked on a more button (most commonly seen with a 3 dots design) the event specifis the location it occured in, and send clickable options
 *
 * @param {restaurantsMoreButtonClickParams} params - The parameters for this event
 * @property {string} clickableOptions - an array containing all the clickable option that open when you click on a more button. This does not include gray buttons that are unclickable
 * @property {string} origin - a button/area from where the action originated from. for example an origin of a modal load can be a specific button that triggered it's load
 * @property {string} pageName - name of the page
 * @property {string} product - the specific product this event is related to: menus/table reservations/orders etc
 * @property {GUID} locationId - -
 * @property {boolean} isDefaultLocation - isDefaultLocation
 * @property {boolean} isDeletedLocation - isDeletedLocation
 * @return {LogObject<restaurantsMoreButtonClickParams>} LogObject<restaurantsMoreButtonClickParams>
 */
export function restaurantsMoreButtonClick(params) {
    return { evid: 21, src: 159, endpoint: 'restaurants', params: params };
}
/**
 * A function to create a log object for the 'restaurantsBmPageStartedLoading' event (evid: 219)
 *
 * Event description: Page in restaurants app started load loaded
 *
 * @param {restaurantsBmPageStartedLoadingParams} params - The parameters for this event
 * @property {string} referralInfo - The specific trigger that made triggered the page load
 * @property {string} previousPage - The page that was loaded before this one
 * @property {string} pageName - name of the page
 * @property {string} hosting - describes the source the page loaded in, with the following format: the source|site builder type. for example: editor|WIX means that the page was loaded inside the editor pop up window, and the site uses regular editor. For devs: hosting: `${viewMode}|${brand}`                                    viewMode: mobile = native mobile, dashboard = BM, onbaording = ADI, editor = editor.                                                         brand: Wix = ADI/editor, EditorX = EditorX
 * @property {string} product - the specific product this event is related to: menus/table reservations/orders etc
 * @property {GUID} locationId
 * @property {boolean} isDefaultLocation
 * @property {boolean} isDeletedLocation - if the location is archived
 * @property {string} operationId
 * @property {GUID} operationGroup
 * @property {string} operationStatus - hidden/visible
 * @return {LogObject<restaurantsBmPageStartedLoadingParams>} LogObject<restaurantsBmPageStartedLoadingParams>
 */
export function restaurantsBmPageStartedLoading(params) {
    return { evid: 219, src: 159, endpoint: 'restaurants', params: params };
}
/**
 * A function to create a log object for the 'restaurantsToggleClick' event (evid: 22)
 *
 * Event description: when a user clicks on a toggle and turns it off or turns it on.
 *
 * @param {restaurantsToggleClickParams} params - The parameters for this event
 * @property {string} toggleName - the description of what the toggle is related to
 * @property {string} actionType - toggle_on / toggle_off (value after the user clicked)
 * @property {string} pageName - name of the page the modal loaded in
 * @property {string} product - the specific product this event is related to: menus/table reservations/orders etc
 * @property {GUID} locationId
 * @property {GUID} operationId
 * @property {GUID} operationGroup
 * @property {string} operationStatus - hidden/visible
 * @property {boolean} isDefaultLocation
 * @return {LogObject<restaurantsToggleClickParams>} LogObject<restaurantsToggleClickParams>
 */
export function restaurantsToggleClick(params) {
    return { evid: 22, src: 159, endpoint: 'restaurants', params: params };
}
/**
 * A function to create a log object for the 'dashboardPageLoad' event (evid: 220)
 *
 * Event description: Page in the restaurants app loaded.Note: Owners' app may send parallel pages with the same name. Use browser_family = 'NativeMobile' for Owners' data.
 *
 * @param {dashboardPageLoadParams} params - The parameters for this event
 * @property {string} referralInfo - The specific trigger that made triggered the page load
 * @property {string} previousPage - The page that was loaded before this one
 * @property {number} loadingTime - load time in miliseconds
 * @property {string} category - acts like the product field. Legacy from the old events (is inside dashboard page load)
 * @property {string} pageName - name of the page
 * @property {string} hosting - describes the source the page loaded in, with the following format: the source|site builder type. for example: editor|WIX means that the page was loaded inside the editor pop up window, and the site uses regular editor. For devs:  hosting: `${viewMode}|${brand}`.                                      viewMode: mobile = native mobile, dashboard = BM, onbaording = ADI, editor = editor.                                                         brand: Wix = ADI/editor, EditorX = EditorX
 * @property {GUID} locationId - locationId
 * @property {boolean} isDefaultLocation - isDefaultLocation
 * @property {string} operationStatus - hidden/visible
 * @property {GUID} operationGroup - operationGroup
 * @property {GUID} operationId - operationId
 * @property {string} experienceId - experience id
 * @property {boolean} isDeletedLocation - is deleted location were opened in the page loaded (mainly kanban)
 * @property {number} numoflocations - number of total locations (include hidden and archived)
 *
 * @return {LogObject<dashboardPageLoadParams>} LogObject<dashboardPageLoadParams>
 */
export function dashboardPageLoad(params) {
    return { evid: 220, src: 159, endpoint: 'restaurants', params: params };
}
/**
 * A function to create a log object for the 'restaurantsTooltipLoad' event (evid: 23)
 *
 * Event description: A Tooltip loaded inside one of restaurants' apps
 *
 * @param {restaurantsTooltipLoadParams} params - The parameters for this event
 * @property {string} tooltipText - What is written inside the tooltip
 * @property {string} origin - a button/area from where the action originated from. for example an origin of a tooltip load can be a specific button that triggered it's load
 * @property {string} pageName - name of the page the tooltip loaded in
 * @property {string} product - the specific product this event is related to: menus/table reservations/orders etc
 * @return {LogObject<restaurantsTooltipLoadParams>} LogObject<restaurantsTooltipLoadParams>
 */
export function restaurantsTooltipLoad(params) {
    return { evid: 23, src: 159, endpoint: 'restaurants', params: params };
}
/**
 * A function to create a log object for the 'restaurantsTooltipCloseClick' event (evid: 24)
 *
 * Event description: User closed a tooltip  inside one of restaurants' apps
 *
 * @param {restaurantsTooltipCloseClickParams} params - The parameters for this event
 * @property {string} tooltipText - What is written inside the tooltip
 * @property {string} pageName - name of the page the tooltip loaded in
 * @property {string} product - the specific product this event is related to: menus/table reservations/orders etc
 * @return {LogObject<restaurantsTooltipCloseClickParams>} LogObject<restaurantsTooltipCloseClickParams>
 */
export function restaurantsTooltipCloseClick(params) {
    return { evid: 24, src: 159, endpoint: 'restaurants', params: params };
}
/**
 * A function to create a log object for the 'restaurantsHover' event (evid: 25)
 *
 * Event description: when the user hover on a tooltips / alerts etc.
 *
 * @param {restaurantsHoverParams} params - The parameters for this event
 * @property {string} tabName - if there are no tabs then null
 * @property {string} hoverType - the name of the hover button
 * @property {string} pageName - name of the page the hover is in
 * @property {string} product - the specific product this event is related to: menus/table reservations/orders etc
 * @return {LogObject<restaurantsHoverParams>} LogObject<restaurantsHoverParams>
 */
export function restaurantsHover(params) {
    return { evid: 25, src: 159, endpoint: 'restaurants', params: params };
}
/**
 * A function to create a log object for the 'restaurantsBannerLoad' event (evid: 26)
 *
 * Event description: A Banner loaded inside one of restaurants' apps
 *
 * @param {restaurantsBannerLoadParams} params - The parameters for this event
 * @property {string} origin - a button/area from where the action originated from. for example an origin of a modal load can be a specific button that triggered it's load
 * @property {string} pageName - name of the page the modal loaded in
 * @property {string} bannerName - banner name, naming convention: product.banner-name for example, menus.delete-section
 * @property {string} product - the specific product this event is related to: menus/table reservations/orders etc
 * @return {LogObject<restaurantsBannerLoadParams>} LogObject<restaurantsBannerLoadParams>
 */
export function restaurantsBannerLoad(params) {
    return { evid: 26, src: 159, endpoint: 'restaurants', params: params };
}
/**
 * A function to create a log object for the 'restaurantsLiveSiteErrors' event (evid: 27)
 *
 * Event description: when there are errors in live site
 *
 * @param {restaurantsLiveSiteErrorsParams} params - The parameters for this event
 * @property {string} screenName - -
 * @property {string} errorMessage - -
 * @property {string} context - depends on what the dev wants to put here
 * @property {string} operationId - -
 * @return {LogObject<restaurantsLiveSiteErrorsParams>} LogObject<restaurantsLiveSiteErrorsParams>
 */
export function restaurantsLiveSiteErrors(params) {
    return { evid: 27, src: 159, endpoint: 'restaurants', params: params };
}
/**
 * A function to create a log object for the 'restaurantsEditorSitePagesAndMenuTabSelection' event (evid: 28)
 *
 * Event description: When a restaurants' tab is loaded inside the Site pages and Menu side panel inside the Editor, this event fires.
 * For example, if a user clicks on one of the site's pages, and gets inside the SEO Basics, the event will fire, and point in the tabName field "seo basics"
 *
 * @param {restaurantsEditorSitePagesAndMenuTabSelectionParams} params - The parameters for this event
 * @property {string} tabName - The editor tab name, for example SEO basic
 * @property {string} pageId - The id of the site builder page the action occurred in
 * @property {string} origin - a button/area from where the action originated from. for example an origin of a modal load can be a specific button that triggered it's load
 * @property {string} sitePageName - Name of the page inside the live site/editor. This is something the user can edit
 * @property {GUID} msid - msid
 * @property {string} product - the specific product this event is related to: menus/table reservations/orders etc
 * @property {boolean} isOoi - -
 * @return {LogObject<restaurantsEditorSitePagesAndMenuTabSelectionParams>} LogObject<restaurantsEditorSitePagesAndMenuTabSelectionParams>
 */
export function restaurantsEditorSitePagesAndMenuTabSelection(params) {
    return { evid: 28, src: 159, endpoint: 'restaurants', params: params };
}
/**
 * A function to create a log object for the 'restaurantsEditorSitePagesAndMenuDeletePageAndApp' event (evid: 29)
 *
 * Event description: When a restaurants' tab is loaded inside the Site pages and Menu side panel inside the Editor, and the user press on delete the app from.
 *
 * @param {restaurantsEditorSitePagesAndMenuDeletePageAndAppParams} params - The parameters for this event
 * @property {string} origin - a button/area from where the action originated from. for example an origin of a modal load can be a specific button that triggered it's load
 * @property {GUID} msid - msid
 * @property {string} product - the specific product this event is related to: menus/table reservations/orders etc
 * @return {LogObject<restaurantsEditorSitePagesAndMenuDeletePageAndAppParams>} LogObject<restaurantsEditorSitePagesAndMenuDeletePageAndAppParams>
 */
export function restaurantsEditorSitePagesAndMenuDeletePageAndApp(params) {
    return { evid: 29, src: 159, endpoint: 'restaurants', params: params };
}
/**
 * A function to create a log object for the 'restaurantsUpgradeToPremiumClick' event (evid: 30)
 *
 * Event description: When the user clicked on the 'upgrade' option which leads him to the premium packages page. Please notice this evid is relevant for internal restaurants addition and not to the BM banner.
 *
 * @param {restaurantsUpgradeToPremiumClickParams} params - The parameters for this event
 * @property {string} origin - main page click / after hover and click from the modal that opened
 * @property {string} pageName - -
 * @property {string} product - -
 * @return {LogObject<restaurantsUpgradeToPremiumClickParams>} LogObject<restaurantsUpgradeToPremiumClickParams>
 */
export function restaurantsUpgradeToPremiumClick(params) {
    return { evid: 30, src: 159, endpoint: 'restaurants', params: params };
}
/**
 * A function to create a log object for the 'oloSettingsSchedulingPagePageLoad' event (evid: 500)
 *
 * Event description: when the scheduling page in OLO Settings was loaded
 *
 * @param {oloSettingsSchedulingPagePageLoadParams} params - The parameters for this event
 * @property {string} preorderType - 'timeBounded' | 'weekly'
 * @property {string} referralInfo - The specific trigger that made triggered the page load
 * @property {string} asapFutureHandlingType - "no_future_handling" | "business_days_ahead_handling"
 * @property {number} weeklyTimeOfDayMinutes - -
 * @property {number} atMostInAdvancedValue - (preorders fields only)
 * @property {string} atLeastInAdvancedTimeUnit - (preorders fields only)
 * @property {string} asapType - max/range (asap fields only)
 * @property {boolean} allowOrdersForLaterToday - true/false (asap fields only)
 * @property {number} rangeMinDuration - in minutes (asap fields only)
 * @property {string} schedulingType - asap / preorders_only
 * @property {number} rangeMaxDuration - in minutes (asap fields only)
 * @property {GUID} defaultOperationId - the default operation id that we see on page load
 * @property {number} asapFutureBusinessDays - 0,7,30 or null if not same day
 * @property {number} windowsTimeValue - in minutes (preorders fields only)
 * @property {number} numOperations - the number of the operations that this site has
 * @property {string} operationIds - the operation ids of this site
 * @property {string} windowsTimeUnit - hours/minutes (preorders fields only)
 * @property {string} atMostInAdvancedTimeUnit - (preorders fields only)
 * @property {string} previousPage - The page that was loaded before this one
 * @property {boolean} isTablet - null- no information. true or false when we do know the information
 * @property {string} schedulingValue - asap / preorders_only
 * @property {string} weeklyDayOfWeek - SUNDAY', 'MONDAY', 'TUESDAY', ...
 * @property {number} weeklyTimeOfDayHours - -
 * @property {string} category - settings
 * @property {number} atLeastInAdvancedValue - (preorders fields only)
 * @property {string} pageName - olo_settings_scheduling
 * @property {boolean} operationEnabled - true/false - olo main toggle of enable online orders or not
 * @property {number} maxOptionDuration - in minutes (asap fields only)
 * @property {string} product - olo
 * @property {number} loading_time - load time in milliseconds
 * @property {GUID} locationId - locaion id
 * @property {string} operationStatus - visible/hidden
 * @property {boolean} isDefaultLocation - is_default_location
 * @property {boolean} isDeletedLocation - of the location is archived
 * @property {string} operationId - operation_id
 * @property {GUID} operationGroup - operation  group
 * @property {string} operationName - -
 * @property {boolean} isFirstOperationTab - is it the first operation tab? which the page was opened on.
 * @return {LogObject<oloSettingsSchedulingPagePageLoadParams>} LogObject<oloSettingsSchedulingPagePageLoadParams>
 */
export function oloSettingsSchedulingPagePageLoad(params) {
    return { evid: 500, src: 159, endpoint: 'restaurants', params: params };
}
/**
 * A function to create a log object for the 'oloClicks' event (evid: 501)
 *
 * Event description: some general clicks inside the olo product.
 * pages that are included: scheduling, settings lobby, pickup and delivery
 *
 * @param {oloClicksParams} params - The parameters for this event
 * @property {string} field - what is the area of the clicks? page/scheuling_type_section / asap_only/preorder_only
 * @property {string} actionType - scroll/click / modal_load/start_typing
 * @property {boolean} isTablet - null- no information. true or false when we do know the information
 * @property {string} operationsIds - if its for example settings page with not only one id
 * @property {string} pageName - settings_scheduling....
 * @property {string} refferal_info - additional info that required sometimes
 * @property {string} value - what is the value (button name/ value) of the click. for example  asap / pre_orders_only / learn_how / max_option_range_option / max_option_arrows etc..
 * @property {string} product - olo
 * @property {GUID} locationId
 * @property {boolean} isDeletedLocation - if the location is archived
 * @property {boolean} isDefaultLocation
 * @property {string} operationId
 * @property {GUID} operationGroup
 * @property {string} operationStatus - hidden/visible
 * @return {LogObject<oloClicksParams>} LogObject<oloClicksParams>
 */
export function oloClicks(params) {
    return { evid: 501, src: 159, endpoint: 'restaurants', params: params };
}
/**
 * A function to create a log object for the 'oloSettingsSchedulingPageSave' event (evid: 502)
 *
 * Event description: triggered after a response from the server.when saving the schedule page.
 * when the page is saved as asap, preorder values will be null and vice versa.
 *
 * @param {oloSettingsSchedulingPageSaveParams} params - The parameters for this event
 * @property {string} preorderType - 'timeBounded' | 'weekly'
 * @property {string} asapFutureHandlingType - "no_future_handling" | "business_days_ahead_handling
 * @property {string} errorNumber - number of error if exists, only if there is an error
 * @property {number} weeklyTimeOfDayMinutes - -
 * @property {number} atMostInAdvancedValue - in minutes (preorders fields only)
 * @property {string} atLeastInAdvancedTimeUnit - minutes/hours.. (preorders fields only)
 * @property {string} asapType - max/ range (asap fields only)
 * @property {boolean} allowOrdersForLaterToday - true when toggle on or false when toggle off
 * @property {number} rangeMinDuration - in minutes (asap fields only)
 * @property {string} schedulingType - asap/pre-orders
 * @property {number} rangeMaxDuration - in minutes (asap fields only)
 * @property {number} asapFutureBusinessDays - 0,7,30 or null if its asap only
 * @property {number} windowsTimeValue - in minutes, (preorders fields only)
 * @property {string} fieldMask - string of all the fields that were changed in this "save"
 * @property {GUID} operationId - operation id
 * @property {string} windowsTimeUnit - hours/minutes, (preorders fields only)
 * @property {string} errorType - The type of the error - validtion/ server/ etc.. only if there is an error
 * @property {string} atMostInAdvancedTimeUnit - minutes/hours.. (preorders fields only)
 * @property {boolean} isTablet - null- no information. true or false when we do know the information
 * @property {string} weeklyDayOfWeek - 'SUNDAY', 'MONDAY', 'TUESDAY', ...
 * @property {string} errorDescription - erorr_message, only if there is an error
 * @property {number} weeklyTimeOfDayHours - -
 * @property {number} atLeastInAdvancedValue - in minutes (preorders fields only)
 * @property {boolean} isSuccessful - True/ false
 * @property {boolean} operationEnable - true if olo toggle is on and false if olo toggle is off
 * @property {number} maxOptionDuration - in minutes (asap fields only)
 * @property {GUID} operationGroup - operation group
 * @property {GUID} locationId - location id
 * @property {boolean} isDefaultLocation - is default location
 * @property {string} operationStatus - visible/hidden
 * @property {string} orderPacingSchedule - days and hours
 * @property {boolean} isOrderPacingScheduled - if the order pacing is applied on certain days and times
 * @property {boolean} isOrderPacingEnabled - if order pacing toggle is on
 * @property {number} orderPacingOrderLimit - orders capacity configured in order pacing
 * @property {string} operationName - -
 * @property {boolean} isFirstOperationTab -  is it the first operation tab? which the page was opened on.
 * @return {LogObject<oloSettingsSchedulingPageSaveParams>} LogObject<oloSettingsSchedulingPageSaveParams>
 */
export function oloSettingsSchedulingPageSave(params) {
    return { evid: 502, src: 159, endpoint: 'restaurants', params: params };
}
/**
 * A function to create a log object for the 'oloOrdersPageLoad' event (evid: 503)
 *
 * Event description: when the page is loaded and also the tab, we will distinguish between tab and page by the field “origin”. only kanban view!
 *
 * @param {oloOrdersPageLoadParams} params - The parameters for this event
 * @property {number} numOrdersInAccepted - -
 * @property {boolean} isAcceptedDisplay - display on the view
 * @property {number} numOrdersOurForDelivery - -
 * @property {number} numOrdersInPending - -
 * @property {boolean} isOutForDeliveryDisplay - display on the view
 * @property {GUID} operationId - -
 * @property {number} numColumns - num columns that are displayed on the orders page
 * @property {string} previousPage - The page that was loaded before this one
 * @property {boolean} isTablet - -
 * @property {number} loadingTime - load time in milliseconds
 * @property {boolean} isPendingApprovalDisplay - display on the view
 * @property {boolean} enableOrdersStatus - true or false (like old olo toggle)
 * @property {string} pageName - orders_page_kanban_view / orders_page_calendar_view
 * @property {number} numOrdersInReady - -
 * @property {string} refferal_info - The specific trigger that made triggered the page load
 * @property {boolean} isDefaultOperation - True / false - s it the default operation when the page is loaded?
 * @property {boolean} isReadyDisplay - display on the view
 * @property {string} product - OLO
 * @property {string} currentStatus - current restaurant status
 * @property {string} operatinID
 * @property {GUID} operationGroup
 * @property {GUID} locationId
 * @property {boolean} isDefaultLocation
 * @property {string} operationStatus - hidden/visible
 * @property {boolean} isDeletedLocation
 * @return {LogObject<oloOrdersPageLoadParams>} LogObject<oloOrdersPageLoadParams>
 */
export function oloOrdersPageLoad(params) {
    return { evid: 503, src: 159, endpoint: 'restaurants', params: params };
}
/**
 * A function to create a log object for the 'oloOrdersCalendarViewTabLoad' event (evid: 504)
 *
 * Event description: when the page is loaded and also the tab, we will distinguish between tab and page by the field “origin”. only calendar view!
 *
 * @param {oloOrdersCalendarViewTabLoadParams} params - The parameters for this event
 * @property {GUID} operationId - -
 * @property {string} previousPage - The page that was loaded before this one
 * @property {boolean} isTablet - -
 * @property {number} loadingTime - load time in milliseconds
 * @property {number} totalWeeklyNumOrders - how many orders in all week?
 * @property {DateTime} dateWithMaxNumOrders - the day with the maximum number of orders. null if this is more than one date
 * @property {boolean} enableOrdersStatus - true or false (like old olo toggle)
 * @property {string} pageName - orders_page_kanban_view / orders_page_calendar_view
 * @property {string} refferal_info - The specific trigger that made triggered the page load
 * @property {boolean} isDefaultOperation - True / false - s it the default operation when the page is loaded?
 * @property {number} numOrdersOfMaxColumn - the number of orders in the day with the maximum number of orders.
 * @property {string} product - OLO
 * @property {string} currentStatus - current restaurant status
 * @property {GUID} locationId
 * @property {string} operationStatus - hidden/visible
 * @property {boolean} isDefaultLocation
 * @property {GUID} operationGroup
 * @return {LogObject<oloOrdersCalendarViewTabLoadParams>} LogObject<oloOrdersCalendarViewTabLoadParams>
 */
export function oloOrdersCalendarViewTabLoad(params) {
    return { evid: 504, src: 159, endpoint: 'restaurants', params: params };
}
/**
 * A function to create a log object for the 'oloOrdersPageMeaningfulAction' event (evid: 505)
 *
 * Event description: all the meaningful actions like: accept, mark as ready, mark as fulfilled, picked up, print, reject and more..
 *
 * @param {oloOrdersPageMeaningfulActionParams} params - The parameters for this event
 * @property {string} field - what is the area of the clicks? ןin kanba V1 - 3 dots  or primary_action_button .
 * @property {string} orderId - -
 * @property {number} deliveryCostInUsd - delivery_cost_in_usd
 * @property {GUID} operationId - -
 * @property {boolean} isTablet - true/false
 * @property {string} pageName - orders_kanban_view / orders_calendar_view
 * @property {string} fulfillmentType - pickup/delivery
 * @property {boolean} isSuccessful - did we get a success response from the server?
 * @property {string} value - the action itself like print, accept, mark as ready, reject and more
 * @property {string} product - olo
 * @property {string} currentStatus - the status before the action. For example, order was pending and then I click on accept so value = “accept” and current_status = ‘pending’
 * @property {GUID} operationGroup - operationGroup
 * @property {string} operationStatus - hidden/visible
 * @property {boolean} isDefaultLocation - action happen on site's default location
 * locationId
 * @property {GUID} locationId - locationId
 * @property {boolean} isDeletedLocation - action happened on deleted location
 * @property {string} deliveryPartner - If the order connected to a delivery partner such as doordash it will send 'doordash'. Otherwise null
 * @property {string} contact_id - contact id if the user clicked on the order's contact
 * @property {string} thirdPartyAppId - thirdPartyAppId in cases that third party app added order action slot in kanban(and user used it)
 * @property {DateTime} dueDateFrom - the date that order should be ready (the range if between from to "to" so this is the from value)
 * @property {string} source - where is the order from? Manually? POS?
 * @property {DateTime} dueDateTo - (the range if between from to "to" so this is the "to" value)
 * @property {string} operationName - -
 * @property {string} errorMessages - -
 * @return {LogObject<oloOrdersPageMeaningfulActionParams>} LogObject<oloOrdersPageMeaningfulActionParams>
 */
export function oloOrdersPageMeaningfulAction(params) {
    return { evid: 505, src: 159, endpoint: 'restaurants', params: params };
}
/**
 * A function to create a log object for the 'oloOrderingStatusComponentIsLoaded' event (evid: 506)
 *
 * Event description: when the component in the right corner in the top part of the page of ordering status is loaded (its loading is separate from the page load)
 *
 * @param {oloOrderingStatusComponentIsLoadedParams} params - The parameters for this event
 * @property {boolean} successfully - true/false
 * @property {string} orderingStatus - unable_to_accept_orders / ready_to_accept_orders
 * @property {number} loadingTime - in miliseconds
 * @property {GUID} locationId
 * @property {string} operationStatus - hidden/visible
 * @property {GUID} operationId
 * @property {GUID} operationGroup
 * @property {boolean} isDefaultLocation
 * @return {LogObject<oloOrderingStatusComponentIsLoadedParams>} LogObject<oloOrderingStatusComponentIsLoadedParams>
 */
export function oloOrderingStatusComponentIsLoaded(params) {
    return { evid: 506, src: 159, endpoint: 'restaurants', params: params };
}
/**
 * A function to create a log object for the 'oloOrderingStatusComponentClicks' event (evid: 507)
 *
 * Event description: The click on the status button itself and the clicks inside it
 *
 * @param {oloOrderingStatusComponentClicksParams} params - The parameters for this event
 * @property {string} buttonName - unable_to_accept_orders/ review_orderins_settings/ set_up_payment / upgrade_to_premium/ lear_more_test_order
 * @property {string} orderingStatus - unable_to_accept_orders / ready_to_accept_orders
 * @property {GUID} locationId - locationId
 * @property {boolean} isDefaultLocation - is_default Location
 * @property {boolean} isDeletedLocation - is deleted location
 * @return {LogObject<oloOrderingStatusComponentClicksParams>} LogObject<oloOrderingStatusComponentClicksParams>
 */
export function oloOrderingStatusComponentClicks(params) {
    return { evid: 507, src: 159, endpoint: 'restaurants', params: params };
}
/**
 * A function to create a log object for the 'oloLiveSiteItemModalOpened' event (evid: 508)
 *
 * Event description: Item Modal opened
 *
 * @param {oloLiveSiteItemModalOpenedParams} params - The parameters for this event
 * @property {number} minItemPrice - the minimum price if there is a price variation
 * @property {number} numPriceVariations - -
 * @property {number} numModifiers - -
 * @property {GUID} sectionId - won't be sent always- if it was opened from the cart it will be null. if it sent from the olo page it will send a value
 * @property {GUID} itemId - -
 * @property {number} numModifiersGroups - -
 * @property {string} itemName - -
 * @property {number} num_labels - -
 * @property {GUID} menuId - won't be sent always- if it was opened from the cart it will be null. if it sent from the olo page it will send a value
 * @property {GUID} operationGroup
 * @property {GUID} locationId
 * @property {boolean} isDefaultLocation
 * @property {boolean} isMenuItemAvailable - available / unavailable
 * @property {boolean} isItemInStock - in_stock / out_of_stock (added only on July 2024)
 * @property {string} operationId - -
 * @return {LogObject<oloLiveSiteItemModalOpenedParams>} LogObject<oloLiveSiteItemModalOpenedParams>
 */
export function oloLiveSiteItemModalOpened(params) {
    return { evid: 508, src: 159, endpoint: 'restaurants', params: params };
}
/**
 * A function to create a log object for the 'oloLiveSiteAddDishToCart' event (evid: 509)
 *
 * Event description: Add Dish To Cart
 *
 * @param {oloLiveSiteAddDishToCartParams} params - The parameters for this event
 * @property {string} priceVariationName - price_variation_name
 * @property {string} errorMessage - some error messages that are shown to the user
 * @property {string} selectedModifiersList - (‘extras: chips, tomatos…. Milk type: soy’) from 14.7 the data structure has changed
 * @property {number} amountOfItems - how many items from this dish the uou add?
 * @property {boolean} isSuccess - true/false
 * @property {number} itemPrice - -
 * @property {GUID} sectionId - -
 * @property {GUID} itemId - -
 * @property {string} itemName - -
 * @property {number} numSelectedModifiers - how many modofiers were selected?
 * @property {number} num_labels - -
 * @property {GUID} menuId - -
 * @property {string} labelsList - -
 * @property {string} priceOfItem - we should cast it into double in order to use it as. a string
 * @property {GUID} operaionGroup
 * @property {GUID} locationId
 * @property {boolean} isDefaultLocation
 * @property {string} operatinID - -
 * @property {string} operationId - -
 * @return {LogObject<oloLiveSiteAddDishToCartParams>} LogObject<oloLiveSiteAddDishToCartParams>
 */
export function oloLiveSiteAddDishToCart(params) {
    return { evid: 509, src: 159, endpoint: 'restaurants', params: params };
}
/**
 * A function to create a log object for the 'oloLiveSiteOloPageLoaded' event (evid: 511)
 *
 * Event description: when olo page in live site loaded to uou
 *
 * @param {oloLiveSiteOloPageLoadedParams} params - The parameters for this event
 * @property {boolean} isFreddDeliveryDisplayed - true/false
 * @property {number} freeDeliveryAboveValue - the value of free delivery above
 * @property {number} numSections - -
 * @property {number} deliveryFee - value or null
 * @property {string} statusDisplayed - accepting_orders / closed / temporary closed/ opening soon / closing soon etc....
 * @property {number} cartState - how many items in the cart when the page was loaded
 * @property {boolean} isFreddDeliveryAboveDisplayed - true/false
 * @property {boolean} isDeafultAddress - true/false
 * @property {boolean} isMinOrderDisplayed - true/false
 * @property {boolean} isDeliveryAvailable - at the time of the page load
 * @property {GUID} operationId - -
 * @property {string} defaultSelectedFulfillment - usually pickup but if its close and the users have delivery so delivery and if not so it will be null
 * @property {number} numMenus - -
 * @property {boolean} isPickupConfig - -
 * @property {boolean} isMemberLoggedIn - true/false
 * @property {string} minOrderDisplayed - value or null
 * @property {string} mode - live site/ preview
 * @property {number} numDishes - -
 * @property {boolean} isDeliveryConfig - -
 * @property {string} defaultSelectedTimeSlot - -
 * @property {boolean} isPickupAvailable - at the time of the page load
 * @property {GUID} operationGroup
 * @property {boolean} isDefaultLocation
 * @property {GUID} locationId
 * @property {string} refferalInfo - is the uou came to the live site from Google? (order with google)?
 * @return {LogObject<oloLiveSiteOloPageLoadedParams>} LogObject<oloLiveSiteOloPageLoadedParams>
 */
export function oloLiveSiteOloPageLoaded(params) {
    return { evid: 511, src: 159, endpoint: 'restaurants', params: params };
}
/**
 * A function to create a log object for the 'oloPickupDeliverySettingsPageLoaded' event (evid: 512)
 *
 * Event description: Pickup & Delivery Settings -> Page Loaded
 *
 * @param {oloPickupDeliverySettingsPageLoadedParams} params - The parameters for this event
 * @property {boolean} pickupLoadSuccess - -
 * @property {number} numEnabledDeliveries - -
 * @property {boolean} enablePickup - (toggle on- true. Toggle off- false)
 * @property {number} numDeliveries - -
 * @property {string} defaultFulfillmentType - pickup/delivery/ pickup_only/delivery_only / no_methods_enabled
 * @property {boolean} deliveriesLoadSuccess - -
 * @property {string} operationStatus - hidden/visible
 * @property {GUID} locationId
 * @property {boolean} isDefaultLocation
 * @property {boolean} isDeletedLocation - if the location is archived
 * @property {GUID} operationGroup
 * @property {boolean} isDdPartnerEnabled - is door dash toggle is on/off/null because the site doesn't have DD.
 * @property {string} operationId - -
 * @property {string} operationName - -
 * @property {boolean} isFirstOperationTab -  is it the first operation tab? which the page was opened on.
 * @return {LogObject<oloPickupDeliverySettingsPageLoadedParams>} LogObject<oloPickupDeliverySettingsPageLoadedParams>
 */
export function oloPickupDeliverySettingsPageLoaded(params) {
    return { evid: 512, src: 159, endpoint: 'restaurants', params: params };
}
/**
 * A function to create a log object for the 'oloDeliveryAreaPageLoad' event (evid: 513)
 *
 * Event description: delivery area page load
 *
 * @param {oloDeliveryAreaPageLoadParams} params - The parameters for this event
 * @property {number} freeDeliveryAboveValue - null if there is no value
 * @property {number} deliveryFee - -
 * @property {string} availableTimes - {"FRIDAY":[{"end_time":"23:59","start_time":"00:00"}],"MONDAY":
 * @property {number} numTimeSlots - -
 * @property {boolean} isDefaultAddress - true/false - relevant only for radius
 * @property {number} orderMin - in order to get the accurate value divide by 100
 * @property {string} radiusUnit - -
 * @property {number} radius - only if chosen, if not so null
 * @property {boolean} isSuccess - page load success
 * @property {number} numOfAvailbaleDays - how many days are checked
 * @property {boolean} offerFreeDelivery - true if checked and  false if uncheck.
 * @property {number} numPostalCodes - -
 * @property {string} actionType - create/edit
 * @property {number} customAreaNumOfPoints - -
 * @property {string} postalCodeCountry - -
 * @property {GUID} fulfillmentId - when its delivery area or pickup
 * @property {number} deliveryTime - in minutes
 * @property {string} areaType - radius, zip/postal codes , draw_on_map
 * @property {number} radiusDistance - -
 * @property {boolean} isEnabled - if toggle on then true  if toggle off then false
 * @property {number} numZipCodes - only if chosen, if not so null
 * @property {string} fulfillmentName - -
 * @property {GUID} operationGroup
 * @property {GUID} locationId
 * @property {boolean} isDeletedLocation - if the location is archived
 * @property {boolean} isDefaultLocation
 * @property {string} operationStatus - hidden/visible
 * @property {string} deliveryPartner - Which delivery partner is used, for example 'doordash', notice if null there is no delivery partner
 * @property {boolean} isDdReadyMessageDisplayed - true/false/null. the green message of Doordash drive is ready to use
 * @property {string} errorMessage - if is_successful = false
 * @property {string} violationMessage - If the page was loaded successfully but something with the integration with DD is not working well.
 * @property {boolean} IsDdFirstFwStepDone - true/false/null
 * if all 3 steps are done = true so the FW won't appear anymore unless one of the steps is back to be not done.
 * @property {boolean} IsDdSecondFwStepDone - true/false/null
 * if all 3 steps are done = true so the FW won't appear anymore unless one of the steps is back to be not done.
 * @property {boolean} IsDdThirdFwStepDone - true/false/null
 * if all 3 steps are done = true so the FW won't appear anymore unless one of the steps is back to be not done.
 * @property {string} operationId - -
 * @property {string} operationName - -
 * @property {boolean} isFirstOperationTab - is it the first operation tab? which the page was opened on.
 * @return {LogObject<oloDeliveryAreaPageLoadParams>} LogObject<oloDeliveryAreaPageLoadParams>
 */
export function oloDeliveryAreaPageLoad(params) {
    return { evid: 513, src: 159, endpoint: 'restaurants', params: params };
}
/**
 * A function to create a log object for the 'oloDeliveryAreaSaved' event (evid: 514)
 *
 * Event description: delivery area saved
 *
 * @param {oloDeliveryAreaSavedParams} params - The parameters for this event
 * @property {number} freeDeliveryAboveValue - null if there is no value
 * @property {number} deliveryFee - -
 * @property {string} availableTimes - {"FRIDAY":[{"end_time":"23:59","start_time":"00:00"}],"MONDAY":
 * @property {number} numTimeSlots - -
 * @property {number} orderMin - in order to get the accurate value divide by 100
 * @property {string} fieldMask - fields that were changed
 * @property {string} radiusUnit - -
 * @property {number} radius - Min radius chosen (if radius is chosen)
 * @property {boolean} isSuccess - is save success
 * @property {number} numOfAvailbaleDays - how many days are checked
 * @property {boolean} offerFreeDelivery - true if checked and  false if uncheck.
 * @property {number} numPostalCodes - -
 * @property {string} actionType - create/edit
 * @property {number} customAreaNumOfPoints - -
 * @property {string} postalCodeCountry - -
 * @property {GUID} fulfillmentId - when its delivery area or pickup
 * @property {number} deliveryTime - in minutes
 * @property {string} areaType - radius, zip/postal codes , draw_on_map
 * @property {number} radiusDistance - Max raduis chosen
 * @property {boolean} isEnabled - if toggle on then true  if toggle off then false
 * @property {string} fulfillmentName - -
 * @property {GUID} operationGroup
 * @property {GUID} locationId
 * @property {boolean} isDefaultLocation
 * @property {string} operationStatus - hidden/visible
 * @property {string} deliveryPartner - 	Which delivery partner is used, for example 'doordash', notice if null there is no delivery partner
 * @property {string} postalCodesList - list of all postal codes
 * @property {boolean} isFirstOperationTab -  is it the first operation tab? which the page was opened on.
 * @property {GUID} operationId - -
 * @property {string} operationName - -
 * @return {LogObject<oloDeliveryAreaSavedParams>} LogObject<oloDeliveryAreaSavedParams>
 */
export function oloDeliveryAreaSaved(params) {
    return { evid: 514, src: 159, endpoint: 'restaurants', params: params };
}
/**
 * A function to create a log object for the 'oloDeliveryAreaDeleted' event (evid: 515)
 *
 * Event description: OLO -> Delivery Area -> Dleted
 *
 * @param {oloDeliveryAreaDeletedParams} params - The parameters for this event
 * @property {number} freeDeliveryAboveValue - null if there is no value
 * @property {number} numOfAvailableDays - how many days are checkes
 * @property {number} deliveryFee - -
 * @property {string} availableTimes - {"FRIDAY":[{"close":"23:59","open":"00:00"}],"MONDAY":[{"close":"23:59","open":"00
 * @property {number} numTimeSlots - -
 * @property {number} orderMin - -
 * @property {string} radiusUnit - -
 * @property {boolean} isSuccess - -
 * @property {boolean} offerFreeDelivery - true if checked and  false if uncheck.
 * @property {number} numPostalCodes - -
 * @property {number} numOfPoints - -
 * @property {number} customAreaNumOfPoints - -
 * @property {string} postalCodeCountry - -
 * @property {string} fulfillmentId - -
 * @property {number} deliveryTime - in minutes
 * @property {string} areaType - radius, postal codes , draw_on_map
 * @property {number} radiusDistance - -
 * @property {boolean} isEnabled - if toggle on then true if toggle off then false
 * @property {string} fulfillmentName - -
 * @property {GUID} operationGroup
 * @property {GUID} locationId
 * @property {boolean} isDefaultLocation
 * @property {string} operationStatus - hidden/visible
 * @property {GUID} operationId - -
 * @property {string} operationName - -
 * @property {boolean} isFirstOperationTab - new field .  is it the first operation tab? which the page was opened on.
 * @return {LogObject<oloDeliveryAreaDeletedParams>} LogObject<oloDeliveryAreaDeletedParams>
 */
export function oloDeliveryAreaDeleted(params) {
    return { evid: 515, src: 159, endpoint: 'restaurants', params: params };
}
/**
 * A function to create a log object for the 'oloPickupPageLoad' event (evid: 516)
 *
 * Event description: OLO -> Pickup Page -> Load
 *
 * @param {oloPickupPageLoadParams} params - The parameters for this event
 * @property {number} numOfAvailableDays - how many days are checked
 * @property {string} availableTimes - long json of all days and hours
 * @property {number} numTimeSlots - -
 * @property {boolean} isDefaultAddress - true/false
 * @property {number} orderMin - -
 * @property {string} fulfillmentId - -
 * @property {boolean} isEnabled - true/false
 * @property {number} numOfDays - -
 * @property {GUID} operationGroup
 * @property {GUID} locationId
 * @property {boolean} isDeletedLocation -  if the location is archived
 * @property {boolean} isDefaultLanguage
 * @property {string} operationStatus - hidden/visible
 * @property {GUID} operationId - -
 * @property {string} operationName - -
 * @return {LogObject<oloPickupPageLoadParams>} LogObject<oloPickupPageLoadParams>
 */
export function oloPickupPageLoad(params) {
    return { evid: 516, src: 159, endpoint: 'restaurants', params: params };
}
/**
 * A function to create a log object for the 'oloPickupPageSaved' event (evid: 517)
 *
 * Event description: OLO -> Pickup Page -> Saved
 *
 * @param {oloPickupPageSavedParams} params - The parameters for this event
 * @property {number} numOfAvailableDays - how many days are checked
 * @property {string} availableTimes - json of days and hours
 * @property {number} numTimeSlots - -
 * @property {number} orderMin - -
 * @property {boolean} isSuccess - true/false
 * @property {string} fulfillmentId - -
 * @property {boolean} isDefaultAddress - whether it's the default address we set for the user before he updates his business addresss
 * @property {GUID} operationGroup
 * @property {GUID} locationId
 * @property {string} operationStatus - hidden/visible
 * @property {boolean} isDefaultLocation
 * @property {string} pickupInstructions - (string | null) the pickup instructions
 * @property {GUID} operationId - -
 * @property {string} operationName - -
 * @return {LogObject<oloPickupPageSavedParams>} LogObject<oloPickupPageSavedParams>
 */
export function oloPickupPageSaved(params) {
    return { evid: 517, src: 159, endpoint: 'restaurants', params: params };
}
/**
 * A function to create a log object for the 'oloPickupPageToggleAction' event (evid: 518)
 *
 * Event description: OLO -> Pickup Page - > Toggle action
 *
 * @param {oloPickupPageToggleActionParams} params - The parameters for this event
 * @property {number} numOfAvailableDays - -
 * @property {string} availableTimes - -
 * @property {number} numTimeSlots - -
 * @property {number} orderMin - -
 * @property {boolean} isSuccess - ture false
 * @property {boolean} isCurrentEnabled - true/false - what was the status before the click
 * @property {string} fulfillmentId - -
 * @property {boolean} isEnabled - the click value
 * @property {number} numOfDays - -
 * @property {GUID} operationId - -
 * @property {string} operationStatus - hidden/visible
 * @property {GUID} locationId
 * @property {GUID} operationGroup
 * @property {boolean} isDefaultLocation
 * @property {string} operationName - -
 * @property {boolean} isFirstOperationTab - is it the first operation tab? which the page was opened on.
 * @return {LogObject<oloPickupPageToggleActionParams>} LogObject<oloPickupPageToggleActionParams>
 */
export function oloPickupPageToggleAction(params) {
    return { evid: 518, src: 159, endpoint: 'restaurants', params: params };
}
/**
 * A function to create a log object for the 'oloOwnerAppOnlyActionSheetOpenedGenericEvent' event (evid: 519)
 *
 * Event description: All the action sheets that are opened after clicks on our pages (that act differently than the web and don't have an action sheet/modal on the web, it has just clicks on the web)
 *
 * @param {oloOwnerAppOnlyActionSheetOpenedGenericEventParams} params - The parameters for this event
 * @property {string} field - the area in the page that the click that opened that action sheet is. for example order preperation in scheduling page when the user choose order preparation time
 * @property {string} action_sheet_name - the name of the action sheet
 * @property {GUID} operationId - operation id
 * @property {boolean} isTablet - true/false
 * @property {string} operationsIds - if its for example settings page with not only one id
 * @property {string} pageName - the page name that the action sheet opened from
 * @property {string} defaultValue - what if the default value when the action sheet opened
 * @return {LogObject<oloOwnerAppOnlyActionSheetOpenedGenericEventParams>} LogObject<oloOwnerAppOnlyActionSheetOpenedGenericEventParams>
 */
export function oloOwnerAppOnlyActionSheetOpenedGenericEvent(params) {
    return { evid: 519, src: 159, endpoint: 'restaurants', params: params };
}
/**
 * A function to create a log object for the 'oloNavigationClick' event (evid: 520)
 *
 * Event description: User clicked on a navigation button (any button in the menus app that links to a different page)
 *
 * @param {oloNavigationClickParams} params - The parameters for this event
 * @property {string} destinationPageName - The page that the user is about to land in, for example menus/items etc...
 * @property {string} origin - a button/area from where the action originated from. for example an origin of a modal load can be a specific button that triggered it's load
 * @property {string} pageName - name of the page
 * @property {string} operationId
 * @property {GUID} operationGroup
 * @property {GUID} locationId
 * @property {boolean} isDefaultLocation
 * @property {boolean} isDeletedLocation - if the location is archived
 * @property {string} operationStatus - hidden/visible
 * @return {LogObject<oloNavigationClickParams>} LogObject<oloNavigationClickParams>
 */
export function oloNavigationClick(params) {
    return { evid: 520, src: 159, endpoint: 'restaurants', params: params };
}
/**
 * A function to create a log object for the 'oloFoodOrderingPageClickOnViewTab' event (evid: 521)
 *
 * Event description: click on status view or on calendar view
 *
 * @param {oloFoodOrderingPageClickOnViewTabParams} params - The parameters for this event
 * @property {number} numReadyOrders - -
 * @property {number} numWeeklyAsapOrders - -
 * @property {number} numWeeklyAcceptedOrders - -
 * @property {number} numPendingOrders - -
 * @property {number} numWeeklyReadyOrders - -
 * @property {number} numWeeklyOutForDeliveryOrders - -
 * @property {string} tabName - the name of the tab the user clicked on
 * @property {number} numWeeklyPendingOrders - -
 * @property {number} numAcceptedOrders - -
 * @property {number} numPreorders - -
 * @property {number} numWeeklyPreorders - -
 * @property {number} numWeeklyOrders - num total weekly orders that the use see
 * @property {number} numOutForDeliveryOrders - -
 * @property {string} currentTabName - current tab name
 * @property {number} numAsapOrders - -
 * @property {number} numOrders - -
 * @property {boolean} isDeletedLocation - isDeletedLocation
 * @property {string} operationStatus - hidden/visible
 * @property {GUID} locationId - location id
 * @property {GUID} operationId - operation id
 * @property {GUID} operationGroup - operation group
 * @property {boolean} isDefaultLocation - default location
 * @return {LogObject<oloFoodOrderingPageClickOnViewTabParams>} LogObject<oloFoodOrderingPageClickOnViewTabParams>
 */
export function oloFoodOrderingPageClickOnViewTab(params) {
    return { evid: 521, src: 159, endpoint: 'restaurants', params: params };
}
/**
 * A function to create a log object for the 'oloLiveSiteClickOnItem' event (evid: 522)
 *
 * Event description: click on item - live site
 *
 * @param {oloLiveSiteClickOnItemParams} params - The parameters for this event
 * @property {number} minItemPrice - the minimum price if there is a price variation (It's actually the default price when the item modal is opened, including preselected modifiers) *in cents (need to divide by 100 to get dollars)
 *
 * @property {GUID} sectionId - -
 * @property {GUID} itemId - -
 * @property {string} itemName - -
 * @property {GUID} menuId - -
 * @property {GUID} locationId - -
 * @property {GUID} operationGroup - -
 * @property {boolean} isDefaultLocation - -
 * @property {string} operationId - -
 * @property {boolean} isMenuItemAvailable - available / unavailable
 * @property {boolean} isItemInStock - in_stock / out_of_stock (added only on July 2024)
 * @return {LogObject<oloLiveSiteClickOnItemParams>} LogObject<oloLiveSiteClickOnItemParams>
 */
export function oloLiveSiteClickOnItem(params) {
    return { evid: 522, src: 159, endpoint: 'restaurants', params: params };
}
/**
 * A function to create a log object for the 'oloLiveSiteTrackerPageLoaded' event (evid: 523)
 *
 * Event description: when tracker page loaded
 *
 * @param {oloLiveSiteTrackerPageLoadedParams} params - The parameters for this event
 * @property {DateTime} pickupTime - if its pickup if not so null
 * @property {string} orderId - -
 * @property {DateTime} fulfilledTimeTo - date_time (its also for pickup!), will be null when it's same as the from and not between values
 * @property {string} schedulingType - asap/preorder
 * @property {string} orderStatus - current status that the uou is seeing on the page
 * @property {DateTime} fulfilledTimeFrom - date_time (its also for pickup!)- if the time is not between and its a specific hour so delivery time to will be null
 * @property {string} deliveryTime - if its delivery if not so null
 * @property {string} fulfillmentType - pickup/delivery
 * @property {string} fulfillmentName - -
 * @property {GUID} operationGroup
 * @property {GUID} locationId
 * @property {boolean} isDefaultLocation
 * @property {string} operationId - -
 * @return {LogObject<oloLiveSiteTrackerPageLoadedParams>} LogObject<oloLiveSiteTrackerPageLoadedParams>
 */
export function oloLiveSiteTrackerPageLoaded(params) {
    return { evid: 523, src: 159, endpoint: 'restaurants', params: params };
}
/**
 * A function to create a log object for the 'oloDeliveryAreaToggleAction' event (evid: 524)
 *
 * Event description: delivery area toggle action
 *
 * @param {oloDeliveryAreaToggleActionParams} params - The parameters for this event
 * @property {number} freeDeliveryAboveValue - null if there is no value
 * @property {number} deliveryFee - -
 * @property {string} availableTimes - {"FRIDAY":[{"end_time":"23:59","start_time":"00:00"}],"MONDAY":
 * @property {number} numOdPoints - only if chosen, if not so null (draw on map)
 * @property {number} zipCodeCountry - only if chosen, if not so null
 * @property {number} numTimeSlots - -
 * @property {number} orderMin - in order to get the accurate value divide by 100
 * @property {string} radiusUnit - -
 * @property {number} radius - only if chosen, if not so null
 * @property {boolean} isSuccess - is save success
 * @property {number} numOfAvailbaleDays - how many days are checked
 * @property {boolean} offerFreeDelivery - true if checked and  false if uncheck.
 * @property {number} customAreaNumOfPoints - -
 * @property {boolean} isCurrentEnabled - what is the status before the click
 * @property {string} postalCodeCountry - -
 * @property {GUID} fulfillmentId - when its delivery area or pickup
 * @property {number} deliveryTime - in minutes
 * @property {string} areaType - radius, zip/postal codes , draw_on_map
 * @property {number} radiusDistance - -
 * @property {boolean} isEnabled - the value of the click
 * @property {number} numZipCodes - only if chosen, if not so null
 * @property {string} fulfillmentName - -
 * @property {GUID} locationId
 * @property {GUID} operationId - -
 * @property {GUID} operationGroup
 * @property {boolean} isDefaultLocation
 * @property {string} operationStatus - hidden/visible
 * @property {string} operationName - =
 * @property {boolean} isFirstOperationTab - is it the first operation tab? which the page was opened on.
 * @return {LogObject<oloDeliveryAreaToggleActionParams>} LogObject<oloDeliveryAreaToggleActionParams>
 */
export function oloDeliveryAreaToggleAction(params) {
    return { evid: 524, src: 159, endpoint: 'restaurants', params: params };
}
/**
 * A function to create a log object for the 'restaurantsOloLiveSiteClickOnOnlineOrdersButtonAtTheTopOfThePage' event (evid: 525)
 *
 * Event description: Click on the online orders button at the top of the page on the live site (the navigations buttons)
 *
 * @param {restaurantsOloLiveSiteClickOnOnlineOrdersButtonAtTheTopOfThePageParams} params - The parameters for this event
 * @property {number} cartState - the number of items on the cart
 * @property {boolean} isMemberLoggedIn - true/false
 * @return {LogObject<restaurantsOloLiveSiteClickOnOnlineOrdersButtonAtTheTopOfThePageParams>} LogObject<restaurantsOloLiveSiteClickOnOnlineOrdersButtonAtTheTopOfThePageParams>
 */
export function restaurantsOloLiveSiteClickOnOnlineOrdersButtonAtTheTopOfThePage(params) {
    return { evid: 525, src: 159, endpoint: 'restaurants', params: params };
}
/**
 * A function to create a log object for the 'restaurantsOloLiveSiteClickOnFulfillment' event (evid: 526)
 *
 * Event description: click on fulfillment (pickup/delivery) on the top of the online ordering page (or else - origin field) in a live site
 *
 * @param {restaurantsOloLiveSiteClickOnFulfillmentParams} params - The parameters for this event
 * @property {boolean} isPickupConfigured - is it even an option? is it configured but not available at the moment?
 * @property {boolean} isDeliveryDisplayed - true/false - is it displayed on the online ordering page?
 * @property {string} statusDisplayed - what is the status that displayed at the moment of the click
 * @property {number} cartState - the number of items on the cart
 * @property {string} selectedFulfillment - the fulfiilment that the user clicked on
 * @property {boolean} isPickupDisplayed - true/false - is it displayed on the online ordering page?
 * @property {GUID} operationId - -
 * @property {boolean} isMemberLoggedIn - true/false
 * @property {string} origin - the origin of the click - fulfillment/ change and from where
 * @property {boolean} isDeliveryConfigured - is it even an option? is it configured but not available at the moment?
 * @property {string} currentFulfillment - pickup/delivery- the chosen fulfillment at the time of the click
 * @property {GUID} locationId
 * @property {boolean} isDefaultLocation
 * @property {GUID} operationGroup
 * @property {GUID} defaultLocationID
 * @property {string} menuId - menu_id
 * @return {LogObject<restaurantsOloLiveSiteClickOnFulfillmentParams>} LogObject<restaurantsOloLiveSiteClickOnFulfillmentParams>
 */
export function restaurantsOloLiveSiteClickOnFulfillment(params) {
    return { evid: 526, src: 159, endpoint: 'restaurants', params: params };
}
/**
 * A function to create a log object for the 'restaurantsOloLiveSiteErrorDisplayedInDispatchModal' event (evid: 527)
 *
 * Event description: online orders page on live site -> Error displayed inside the dispatch modal
 *
 * @param {restaurantsOloLiveSiteErrorDisplayedInDispatchModalParams} params - The parameters for this event
 * @property {boolean} isDeliveryDisplayed - true/false - is it displayed on the modal?
 * @property {string} statusDisplayed - what is the status that displayed at the moment of the click
 * @property {number} cartState - the number of items on the cart
 * @property {string} errorMessage - what is the error message? pickup isn’t available at the selected time / pickup isn’t available at the selected date etc….
 * @property {boolean} isPreorderDisplayed - is it displayed in the modal at the moment of the error? is it an option?
 * @property {string} errorField - pickup_later_today_time / pickup_preorder_time / pickup_preorder_time / delivery_address / delivery_late_today_time / delivery_preorder_time/ delivery_preorder_date
 * @property {boolean} isPickupDisplayed - true/false - is it displayed on the modal?
 * @property {GUID} operationId - -
 * @property {string} errorType - error type
 * @property {boolean} isMemberLoggedIn - true/false
 * @property {boolean} isAsapDisplayed - is it displayed in the modal at the moment of the error? is it an option?
 * @property {string} currentFulfillment - pickup/delivery- the chosen fulfillment at the time of the error
 * @property {GUID} operationGroup
 * @property {GUID} locationId
 * @property {boolean} isDefaultLocation
 * @property {GUID} defaultLocationID
 * @return {LogObject<restaurantsOloLiveSiteErrorDisplayedInDispatchModalParams>} LogObject<restaurantsOloLiveSiteErrorDisplayedInDispatchModalParams>
 */
export function restaurantsOloLiveSiteErrorDisplayedInDispatchModal(params) {
    return { evid: 527, src: 159, endpoint: 'restaurants', params: params };
}
/**
 * A function to create a log object for the 'restaurantsOloLiveSiteFulfillmentChanged' event (evid: 528)
 *
 * Event description: online orders page on live site -> Fulfillment changed
 *
 * @param {restaurantsOloLiveSiteFulfillmentChangedParams} params - The parameters for this event
 * @property {boolean} isDeliveryDisplayed - true/false - is it displayed on the page?
 * @property {string} statusDisplayed - what is the status that displayed at the moment of the click
 * @property {DateTime} pickupTime - if its not asap so the datetime with the hour and the date of today/ of the preorder date
 * @property {number} cartState - the number of items on the cart
 * @property {boolean} isPreorderDisplayed - is it displayed on the page? is it an option?
 * @property {boolean} isSuccess - true/false
 * @property {boolean} isPickupDisplayed - true/false - is it displayed on the pagel?
 * @property {GUID} operationId - -
 * @property {boolean} isMemberLoggedIn - true/false
 * @property {boolean} isAsapDisplayed - is it displayed of the page? is it an option?
 * @property {string} deliveryTime - -
 * @property {string} pickupTimingType - asap / later_today/preorder
 * @property {string} currentFulfillment - pickup/delivery- the chosen fulfillment before the change
 * @property {string} newFulfillment - what is the new fulfillment? delivery/pikcup
 * @return {LogObject<restaurantsOloLiveSiteFulfillmentChangedParams>} LogObject<restaurantsOloLiveSiteFulfillmentChangedParams>
 */
export function restaurantsOloLiveSiteFulfillmentChanged(params) {
    return { evid: 528, src: 159, endpoint: 'restaurants', params: params };
}
/**
 * A function to create a log object for the 'restaurantsOloLiveSiteDispatchModalOpened' event (evid: 529)
 *
 * Event description: online orders page on live site -> Fulfillment changed
 *
 * @param {restaurantsOloLiveSiteDispatchModalOpenedParams} params - The parameters for this event
 * @property {boolean} isDeliveryDisplayed - true/false - is it displayed on the modal?
 * @property {DateTime} pickupTime - if its not asap so the datetime with the hour and the date of today/ of the preorder date
 * @property {number} cartState - the number of items on the cart
 * @property {boolean} isPreorderDisplayed - is it displayed on the modal? is it an option?
 * @property {number} businessDays - 0,7,30, null
 * @property {string} schedulingType - what is the shceduling type at the moment of the modal load?
 * @property {DateTime} fromDateAndTime - -
 * @property {boolean} isPickupDisplayed - true/false - is it displayed on the modal?
 * @property {GUID} operationId - -
 * @property {DateTime} untilDateAndTime - -
 * @property {boolean} isMemberLoggedIn - Ture.false
 * @property {boolean} isAsapDisplayed - is it displayed of the modal? is it an option?
 * @property {string} deliveryTime - -
 * @property {string} pickupTimingType - asap / later_today/preorder
 * @property {string} currentFulfillment - pickup/delivery- the chosen fulfillment at the moment of the modal load
 * @property {DateTime} dateAndTime - -
 * @property {string} selectedRadioButton - asap/future/null - send only for asap+future
 * @property {string} source - from were the user got to the dispatch - order_now/menu_item
 * @property {GUID} defultLocationId - the id of the defult location
 * @property {GUID} locationId - the location we are now at
 * @property {boolean} isDefaultLocation
 * @property {GUID} operationGroup
 * @return {LogObject<restaurantsOloLiveSiteDispatchModalOpenedParams>} LogObject<restaurantsOloLiveSiteDispatchModalOpenedParams>
 */
export function restaurantsOloLiveSiteDispatchModalOpened(params) {
    return { evid: 529, src: 159, endpoint: 'restaurants', params: params };
}
/**
 * A function to create a log object for the 'restaurantsOloLiveSiteClicksInsideDispatchModal' event (evid: 530)
 *
 * Event description: online orders page on live site -> Clicks inside dispatch modal
 *
 * @param {restaurantsOloLiveSiteClicksInsideDispatchModalParams} params - The parameters for this event
 * @property {string} buttonType - pickup / delivery/deliver_to / delivery_time / delivery_time_in_dropdown / pickup_in_30_mintues / pickup_schedule_for_late_today/pickup_time / pickup_time_in_dropdown / save / location
 * @property {boolean} isPreorder - is the click is preorder related or asap
 * @property {string} currentFulfillment - pickup/delivery- the chosen fulfillment at the moment of the modal load
 * @property {GUID} locationId - the selected location the user clicked on
 * @property {GUID} operationGroup - -
 * @property {GUID} previousLocation - the currennt location_id (from where the user did the select location click)
 * @property {GUID} defultLocationId
 * @property {boolean} isDefaultLocation
 * @property {string} operationId - -
 * @return {LogObject<restaurantsOloLiveSiteClicksInsideDispatchModalParams>} LogObject<restaurantsOloLiveSiteClicksInsideDispatchModalParams>
 */
export function restaurantsOloLiveSiteClicksInsideDispatchModal(params) {
    return { evid: 530, src: 159, endpoint: 'restaurants', params: params };
}
/**
 * A function to create a log object for the 'restaurantsOloLiveSiteDispatchModalClosed' event (evid: 531)
 *
 * Event description: online orders page on live site ->Dispatch modal closed
 *
 * @param {restaurantsOloLiveSiteDispatchModalClosedParams} params - The parameters for this event
 * @property {boolean} isDeliveryDisplayed - true/false - is it displayed on the modal?
 * @property {DateTime} pickupTime - if its not asap so the datetime with the hour and the date of today/ of the preorder date
 * @property {string} changedFields - all the fields that were changed on the save
 * @property {boolean} isPreorderDisplayed - is it displayed on the modal? is it an option?
 * @property {number} businessDays - -
 * @property {string} schedulingType - asap/asap+future/preorder/sameday
 * @property {DateTime} fromDateAndTime - -
 * @property {boolean} isPickupDisplayed - true/false - is it displayed on the modal?
 * @property {GUID} operationId - -
 * @property {DateTime} untilDateAndTime - -
 * @property {boolean} isMemberLoggedIn - true/false
 * @property {boolean} isAsapDisplayed - is it displayed of the modal? is it an option?
 * @property {string} deliveryTime - -
 * @property {string} pickupTimingType - asap / later_today/preorder
 * @property {string} currentFulfillment - pickup/delivery- the chosen fulfillment at the moment of the modal load
 * @property {DateTime} dateAndTime - the date and time of the pickup/delivery
 * @property {string} selectedRadioButton - asap/future/null - send only for asap+future
 * @property {string} triggerName - save/ x_button/ click_outside_modal
 * @property {GUID} locationId
 * @property {boolean} isDefaultLocation
 * @property {GUID} operationGroup
 * @return {LogObject<restaurantsOloLiveSiteDispatchModalClosedParams>} LogObject<restaurantsOloLiveSiteDispatchModalClosedParams>
 */
export function restaurantsOloLiveSiteDispatchModalClosed(params) {
    return { evid: 531, src: 159, endpoint: 'restaurants', params: params };
}
/**
 * A function to create a log object for the 'restaurantsOloLiveSiteOnlineOrdersPageClicksOnMenuBar' event (evid: 532)
 *
 * Event description: online orders page on live site ->Online orders page > Clicks on menu bar
 *
 * @param {restaurantsOloLiveSiteOnlineOrdersPageClicksOnMenuBarParams} params - The parameters for this event
 * @property {number} cartState - the number of items on the cart
 * @property {string} sectionName - the name of the section where clicked
 * @property {number} currentSectionNumber - the number of the section that the uou is see at the time of the click. is it the second one? the first_one?
 * @property {GUID} operationId - -
 * @property {boolean} isMemberLoggedIn - true/false
 * @property {string} sectionId - the id of the sections that was clicked
 * @property {number} numTotalSections - number of all the sections (including duplicates)
 * @property {GUID} locationId
 * @property {boolean} isDefaultLocation
 * @property {GUID} operationGroup
 * @return {LogObject<restaurantsOloLiveSiteOnlineOrdersPageClicksOnMenuBarParams>} LogObject<restaurantsOloLiveSiteOnlineOrdersPageClicksOnMenuBarParams>
 */
export function restaurantsOloLiveSiteOnlineOrdersPageClicksOnMenuBar(params) {
    return { evid: 532, src: 159, endpoint: 'restaurants', params: params };
}
/**
 * A function to create a log object for the 'restaurantsOloLiveSiteOnlineOrdersPageClicksOnMenuDropdownAndOtherMenusInside' event (evid: 533)
 *
 * Event description: online orders page on live site ->Online orders page > Clicks on menu dropdown and other menus inside when there is more than one menu
 *
 * @param {restaurantsOloLiveSiteOnlineOrdersPageClicksOnMenuDropdownAndOtherMenusInsideParams} params - The parameters for this event
 * @property {number} menuNumber - the menu that was clickes -  starts from 0, the first menu will be 0 and the second will be 1 ...
 * @property {string} statusDisplayed - what is the status that displayed at the moment of the click
 * @property {string} currentMenuName - -
 * @property {string} menuName - the name of the menu that was clicked
 * @property {GUID} operationId - -
 * @property {number} currentMenuNumber - the number of the menu that the uou is see at the time of the click. is it the second one? the first_one? - starts from 0, the first menu will be 0 and the second will be 1 ...
 * @property {number} numTotalMenus - number of all the menus (including duplicates))
 * @property {string} buttonName - dropdown / or menu option
 * @property {string} menuId - the id of the menu that was clicked
 * @property {string} currentMenuId - -
 * @property {GUID} locationId
 * @property {boolean} isDefaultLocation
 * @property {GUID} operationGroup
 * @return {LogObject<restaurantsOloLiveSiteOnlineOrdersPageClicksOnMenuDropdownAndOtherMenusInsideParams>} LogObject<restaurantsOloLiveSiteOnlineOrdersPageClicksOnMenuDropdownAndOtherMenusInsideParams>
 */
export function restaurantsOloLiveSiteOnlineOrdersPageClicksOnMenuDropdownAndOtherMenusInside(params) {
    return { evid: 533, src: 159, endpoint: 'restaurants', params: params };
}
/**
 * A function to create a log object for the 'oloServiceFeePageLoad' event (evid: 534)
 *
 * Event description: when service fee page was loaded
 *
 * @param {oloServiceFeePageLoadParams} params - The parameters for this event
 * @property {string} refferal_info - what was the entry point for this page.
 * @property {number} numRules - how many rules are in the page? if 0 so 0
 * @property {GUID} locationId
 * @property {string} operationStatus - hidden/visible
 * @property {boolean} isDefaultLocation
 * @property {GUID} operationId
 * @property {GUID} operationGroup
 * @return {LogObject<oloServiceFeePageLoadParams>} LogObject<oloServiceFeePageLoadParams>
 */
export function oloServiceFeePageLoad(params) {
    return { evid: 534, src: 159, endpoint: 'restaurants', params: params };
}
/**
 * A function to create a log object for the 'oloServiceFeeGenericClicks' event (evid: 535)
 *
 * Event description: Generic clicks on the service page
 *
 * @param {oloServiceFeeGenericClicksParams} params - The parameters for this event
 * @property {string} name - name of the rule
 * @property {string} actionType - click/ modal_opened
 * @property {string} value - 3_dots, edit, click_on_rule, delete , delete_modal_opened , cancel_delete , delete_service_fee
 * @property {GUID} ruleId - -
 * @property {GUID} locationId
 * @property {string} operationStatus - hidden/visible
 * @property {GUID} operationId
 * @property {GUID} operationGroup
 * @property {boolean} isDefaultLocation
 * @return {LogObject<oloServiceFeeGenericClicksParams>} LogObject<oloServiceFeeGenericClicksParams>
 */
export function oloServiceFeeGenericClicks(params) {
    return { evid: 535, src: 159, endpoint: 'restaurants', params: params };
}
/**
 * A function to create a log object for the 'oloServiceFeeServiceFeeModalOpened' event (evid: 536)
 *
 * Event description: Service fee modal opened for edit or create
 *
 * @param {oloServiceFeeServiceFeeModalOpenedParams} params - The parameters for this event
 * @property {number} percentage - if it's edit type
 * @property {string} name - rule name if it's edit type
 * @property {number} subtotalMin - if it's edit type
 * @property {string} ruleType - if it's edit type
 * @property {number} amount - if it's edit type
 * @property {string} taxGroupId - if it's edit type
 * @property {number} subtotalMax - if it's edit type, and only if it's a range
 * @property {string} mode - the modal type edit/create
 * @property {GUID} ruleId - if it's edit type
 * @property {string} fulfillmentTypes - if it's edit type
 * @property {string} operationStatus - hidden/visible
 * @property {GUID} locationId
 * @property {GUID} operationId
 * @property {GUID} operationGroup
 * @return {LogObject<oloServiceFeeServiceFeeModalOpenedParams>} LogObject<oloServiceFeeServiceFeeModalOpenedParams>
 */
export function oloServiceFeeServiceFeeModalOpened(params) {
    return { evid: 536, src: 159, endpoint: 'restaurants', params: params };
}
/**
 * A function to create a log object for the 'oloServiceFeeSaveServiceFee' event (evid: 537)
 *
 * Event description: Save service fee (also create also edit)
 *
 * @param {oloServiceFeeSaveServiceFeeParams} params - The parameters for this event
 * @property {number} percentage - -
 * @property {string} name - -
 * @property {string} errorMessage - if is_success  = false
 * @property {number} subtotalMin - -
 * @property {string} fieldMask - list of fields that were changed
 * @property {boolean} isSuccess - true/false
 * @property {string} ruleType - percentage / amount
 * @property {number} amount - -
 * @property {string} taxGroupId - -
 * @property {number} subtotalMax - -
 * @property {string} mode - create/edit
 * @property {GUID} ruleId - -
 * @property {string} fulfillmentTypes - -
 * @property {string} operationId
 * @property {GUID} operationGroup
 * @property {GUID} locationId
 * @property {boolean} isDefaultLocation
 * @property {string} operationStatus - hidden/visible
 * @return {LogObject<oloServiceFeeSaveServiceFeeParams>} LogObject<oloServiceFeeSaveServiceFeeParams>
 */
export function oloServiceFeeSaveServiceFee(params) {
    return { evid: 537, src: 159, endpoint: 'restaurants', params: params };
}
/**
 * A function to create a log object for the 'oloServiceFeeDeleteServiceFee' event (evid: 538)
 *
 * Event description: Delete service fee
 *
 * @param {oloServiceFeeDeleteServiceFeeParams} params - The parameters for this event
 * @property {number} percentage - -
 * @property {string} name - -
 * @property {string} errorMessage - if is_success  = false
 * @property {number} subtotalMin - -
 * @property {boolean} isSuccess - true/false
 * @property {string} ruleType - -
 * @property {number} amount - -
 * @property {string} taxGroupId - -
 * @property {number} subtotalMax - -
 * @property {GUID} ruleId - -
 * @property {string} fulfillmentTypes - -
 * @property {string} operationId
 * @property {GUID} operationGroup
 * @property {GUID} locationId
 * @property {boolean} isDefaultLocation
 * @property {string} operationStatus - hidden/visible
 * @return {LogObject<oloServiceFeeDeleteServiceFeeParams>} LogObject<oloServiceFeeDeleteServiceFeeParams>
 */
export function oloServiceFeeDeleteServiceFee(params) {
    return { evid: 538, src: 159, endpoint: 'restaurants', params: params };
}
/**
 * A function to create a log object for the 'oloMovedToPickachuSecondStep' event (evid: 539)
 *
 * Event description: when the user create a manuall order. the first step is when user try to add an item and the modal is open. if the user choose an item with modifiers or variants that requires second step of choosing the modal will show the second step. and this event is fired when the second step options are shown to the user
 *
 * @param {oloMovedToPickachuSecondStepParams} params - The parameters for this event
 * @property {number} numModifiers - -
 * @property {string} sectionId - -
 * @property {string} itemId - -
 * @property {number} numModifiersGroups - -
 * @property {boolean} isSuccessful - true/false
 * @property {string} menuId - -
 * @property {number} numVariations - -
 * @property {string} origin - where the pickachu are used (POS/New Order)
 * Null = new order
 * @return {LogObject<oloMovedToPickachuSecondStepParams>} LogObject<oloMovedToPickachuSecondStepParams>
 */
export function oloMovedToPickachuSecondStep(params) {
    return { evid: 539, src: 159, endpoint: 'restaurants', params: params };
}
/**
 * A function to create a log object for the 'oloGenericDebugEvent' event (evid: 540)
 *
 * Event description: Generic Debug Events
 *
 * @param {oloGenericDebugEventParams} params - The parameters for this event
 * @property {string} subjectType - subject type
 * @property {string} hosting - editor/editorX/BM/studio/viewer
 * @property {string} value - JSON
 * @return {LogObject<oloGenericDebugEventParams>} LogObject<oloGenericDebugEventParams>
 */
export function oloGenericDebugEvent(params) {
    return { evid: 540, src: 159, endpoint: 'restaurants', params: params };
}
/**
 * A function to create a log object for the 'oloManualOrderFulfillmentModalContinueClick' event (evid: 541)
 *
 * Event description: User click on continue click inside Fulfillment Modal,and save fulfillment method of manual order. before the actual save of the full manual order
 *
 * @param {oloManualOrderFulfillmentModalContinueClickParams} params - The parameters for this event
 * @property {DateTime} orderTimeTo - the max in the range of pickup/delivery time
 * @property {string} currency - The type of currency
 * @property {DateTime} orderTimeFrom - the min in the range of pickup/delivery time
 * @property {string} fulfillmentMethod - delivery/pickup
 * @property {string} deliveryFeeString - Delivery fee in string format
 * @property {DateTime} futureOrderTime - If it is a future order, then what time is it for?
 * @property {boolean} isCustom - Is the fulfillment method a custom one, or a pre saved one
 * @property {GUID} operationId
 * @property {GUID} locationId
 * @property {GUID} operationGroup
 * @property {string} operationStatus - hidden/visible
 * @property {boolean} isDefaultLocation
 * @return {LogObject<oloManualOrderFulfillmentModalContinueClickParams>} LogObject<oloManualOrderFulfillmentModalContinueClickParams>
 */
export function oloManualOrderFulfillmentModalContinueClick(params) {
    return { evid: 541, src: 159, endpoint: 'restaurants', params: params };
}
/**
 * A function to create a log object for the 'oloPickupDeliveryPageDeafultFulfillmentChangedSuccesfuly' event (evid: 542)
 *
 * Event description: when user changes the default fulfillment or turns on/of one of the toggles and it affects the default fulfillment method(Changed Successfully)
 *
 * @param {oloPickupDeliveryPageDeafultFulfillmentChangedSuccesfulyParams} params - The parameters for this event
 * @property {string} errorNumber - -
 * @property {string} operationIds - -
 * @property {string} currentDefaultFulfillmentStatus - current after change - pickup/delivery/ pickup_only/delivery_only / no_methods_enabled
 * @property {boolean} isAutomaticChange - true/false
 * @property {string} previousDefaultFulfillmentSatus - current after change - pickup/delivery/ pickup_only/delivery_only / no_methods_enabled
 * @property {string} errorDescription - -
 * @property {string} previousDefaultFulfillmentType - before change pickup/delivery
 * @property {string} currentDefaultFulfillmentType - current after change - pickup/delivery/
 * @property {boolean} isSuccessful - true/false
 * @property {GUID} locationId
 * @property {GUID} operationGroup
 * @property {boolean} isDefaultLocation
 * @property {string} operationStatus - hidden/visible
 * @property {GUID} operationId - -
 * @property {string} operationName - -
 * @property {boolean} isFirstOperationTab - -
 * @return {LogObject<oloPickupDeliveryPageDeafultFulfillmentChangedSuccesfulyParams>} LogObject<oloPickupDeliveryPageDeafultFulfillmentChangedSuccesfulyParams>
 */
export function oloPickupDeliveryPageDeafultFulfillmentChangedSuccesfuly(params) {
    return { evid: 542, src: 159, endpoint: 'restaurants', params: params };
}
/**
 * A function to create a log object for the 'oloEditorInstallationSteps' event (evid: 543)
 *
 * Event description: all the steps in the installations in Editor.In order to distinguish between olo/menu/ TR with the implicit app_id
 *
 * @param {oloEditorInstallationStepsParams} params - The parameters for this event
 * @property {boolean} isStudio - True/.false
 * @property {string} lightboxTitle - -
 * @property {string} step - which step in the installation flow is it?
 * @property {string} errorMessage - -
 * @property {boolean} isFirstInstall - True/false
 * @property {string} lightboxId - -
 * @property {GUID} appDefId - app_id that was installed
 * @property {boolean} isInstallationRetry - true/false
 * @property {string} lightboxLayout - -
 * @property {string} origin - -
 * @property {string} lightboxParentRef - -
 * @property {GUID} msid - msid
 * @property {string} value - -
 * @property {string} lightboxWidgetId - -
 * @return {LogObject<oloEditorInstallationStepsParams>} LogObject<oloEditorInstallationStepsParams>
 */
export function oloEditorInstallationSteps(params) {
    return { evid: 543, src: 159, endpoint: 'restaurants', params: params };
}
/**
 * A function to create a log object for the 'oloDoorDashSetupProcessClicks' event (evid: 544)
 *
 * Event description: All clicks in the doordash setup proccess: register, connect payments, enable tip.
 * Also includes uncollapse/collapse clicks
 *
 * @param {oloDoorDashSetupProcessClicksParams} params - The parameters for this event
 * @property {string} completedSteps - Comma separated string of the steps that were completed. for example if all steps were completed it will send: "register,payments,tips"
 * @property {string} field - register/payments/tips/collapse/uncollapse
 * @return {LogObject<oloDoorDashSetupProcessClicksParams>} LogObject<oloDoorDashSetupProcessClicksParams>
 */
export function oloDoorDashSetupProcessClicks(params) {
    return { evid: 544, src: 159, endpoint: 'restaurants', params: params };
}
/**
 * A function to create a log object for the 'oloDoorDashRegistrationModalSubmit' event (evid: 545)
 *
 * Event description: user clicked on submit in the doordash registration modal
 *
 * @param {oloDoorDashRegistrationModalSubmitParams} params - The parameters for this event
 * @property {string} errorDescription - if there was a problem, what caused it
 * @property {boolean} isSuccessful - After clicking register, we get a response from doordash if they created a pending status for this site. This does not mean the site got verification that it is Active!
 * @return {LogObject<oloDoorDashRegistrationModalSubmitParams>} LogObject<oloDoorDashRegistrationModalSubmitParams>
 */
export function oloDoorDashRegistrationModalSubmit(params) {
    return { evid: 545, src: 159, endpoint: 'restaurants', params: params };
}
/**
 * A function to create a log object for the 'oloPickupDeliveryClosureDatesPageLoad' event (evid: 546)
 *
 * Event description: when closure dated page is loaded mobile+web
 *
 * @param {oloPickupDeliveryClosureDatesPageLoadParams} params - The parameters for this event
 * @property {number} pastClosureDates - -
 * @property {GUID} operationId - -
 * @property {number} numClosureDates - the amount of closure dated in the page from 0
 * @property {number} upcomingClosureDates - -
 * @property {string} operationName - -
 * @property {GUID} operationGroup
 * @property {string} operationStatus - hidden/visible
 * @property {GUID} locationId
 * @property {boolean} isDefaultLocation
 * @property {boolean} isDeletedLocation - if the location is archived
 * @property {boolean} isFirstOperationTab - is it the first operation tab? which the page was opened on.
 * @return {LogObject<oloPickupDeliveryClosureDatesPageLoadParams>} LogObject<oloPickupDeliveryClosureDatesPageLoadParams>
 */
export function oloPickupDeliveryClosureDatesPageLoad(params) {
    return { evid: 546, src: 159, endpoint: 'restaurants', params: params };
}
/**
 * A function to create a log object for the 'oloClosureDatesCreateEditClosureDateModalScreenLoad' event (evid: 547)
 *
 * Event description: when user opened closure date create/edit modal or the edit/create screen in the owner app load
 *
 * @param {oloClosureDatesCreateEditClosureDateModalScreenLoadParams} params - The parameters for this event
 * @property {string} name - -
 * @property {boolean} isAllDay - true./false
 * @property {GUID} closureDateId - -
 * @property {string} affectedMethods - string ('all_fulfillment_method' | 'all_delivery_fulfillment_methods' | 'all_pickup_fulfillment_methods' | 'specific_fulfillment_methods'
 * @property {GUID} operationId - -
 * @property {string} fulfillmentMethodIds - string/null (only relevant if the affectedMethods value is 'specific_fulfillment_methods', will be a list of ids - 'id-1,id-2,id-3'
 * @property {DateTime} end - the end date
 * @property {DateTime} start - the start date
 * @property {GUID} operationGroup
 * @property {boolean} isDefaultLocation
 * @property {GUID} locationId
 * @property {string} operationStatus - hidden/visible
 * @property {string} operationName - -
 * @return {LogObject<oloClosureDatesCreateEditClosureDateModalScreenLoadParams>} LogObject<oloClosureDatesCreateEditClosureDateModalScreenLoadParams>
 */
export function oloClosureDatesCreateEditClosureDateModalScreenLoad(params) {
    return { evid: 547, src: 159, endpoint: 'restaurants', params: params };
}
/**
 * A function to create a log object for the 'oloClosureDateSaveSuccessFailure' event (evid: 548)
 *
 * Event description: is the closure date saved successfully or there was any error?
 *
 * @param {oloClosureDateSaveSuccessFailureParams} params - The parameters for this event
 * @property {string} name - -
 * @property {boolean} isAllDay - true./false
 * @property {GUID} closureDateId - -
 * @property {string} affectedMethods - string ('all_fulfillment_method' | 'all_delivery_fulfillment_methods' | 'all_pickup_fulfillment_methods' | 'specific_fulfillment_methods'
 * @property {GUID} operationId - -
 * @property {boolean} allDay - whether the closure spans across a full day or a time range
 * @property {string} errorDescription - -
 * @property {string} restaurantTimezone - -
 * @property {string} fulfillmentMethodIds - string/null (only relevant if the affectedMethods value is 'specific_fulfillment_methods', will be a list of ids - 'id-1,id-2,id-3'
 * @property {DateTime} end - the end date
 * @property {DateTime} start - the start date
 * @property {boolean} isSuccessful - true/false
 * @property {string} clientTimezone - -
 * @property {string} operationName - -
 * @property {GUID} operationGroup
 * @property {GUID} locationId
 * @property {string} operationStatus - hidden/visible
 * @property {boolean} isDefaultLocation
 * @return {LogObject<oloClosureDateSaveSuccessFailureParams>} LogObject<oloClosureDateSaveSuccessFailureParams>
 */
export function oloClosureDateSaveSuccessFailure(params) {
    return { evid: 548, src: 159, endpoint: 'restaurants', params: params };
}
/**
 * A function to create a log object for the 'oloClosureDateDeleteSuccessFailure' event (evid: 549)
 *
 * Event description: is the closure date deleted successfully or there was any error?
 *
 * @param {oloClosureDateDeleteSuccessFailureParams} params - The parameters for this event
 * @property {string} name - -
 * @property {boolean} isAllDay - true./false
 * @property {GUID} closureDateId - -
 * @property {string} affectedMethods - string ('all_fulfillment_method' | 'all_delivery_fulfillment_methods' | 'all_pickup_fulfillment_methods' | 'specific_fulfillment_methods'
 * @property {GUID} operationId - -
 * @property {string} errorDescription - -
 * @property {string} fulfillmentMethodIds - string/null (only relevant if the affectedMethods value is 'specific_fulfillment_methods', will be a list of ids - 'id-1,id-2,id-3'
 * @property {DateTime} end - the end date
 * @property {DateTime} start - the start date
 * @property {boolean} isSuccessful - true/false
 * @property {string} operationStatus - hidden/visible
 * @property {GUID} locationId
 * @property {GUID} operationGroup
 * @property {boolean} isDefaultLocation
 * @property {string} operationName - -
 * @property {boolean} isFirstOperationTab - is it the operations that the page opened on for the first time?
 * @return {LogObject<oloClosureDateDeleteSuccessFailureParams>} LogObject<oloClosureDateDeleteSuccessFailureParams>
 */
export function oloClosureDateDeleteSuccessFailure(params) {
    return { evid: 549, src: 159, endpoint: 'restaurants', params: params };
}
//# sourceMappingURL=index.js.map